module.exports = [
	{
		"templateId": "default",
		"templateName": "Basic Newsletter",
		"templateCategory": "",
		"templateContent": [
			{
				"configId": "ROOT_ITEM",
				"contentId": "By8akQ1g-",
				"contentIsRoot": true,
				"contentParentId": null
			},
			{
				"configId": "SECTION",
				"contentId": "S1mAJX1eW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "S1qUlXylb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"styleBackgroundColour": "#7f58a5",
				"contentId": "HkpPHQkgb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "BywsHXJlW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "SkRhSXklW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HkspHQJeb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "SywTUQyeW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "rJhT8QyxZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "ByxRIQ1x-",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "r1R6U7JeZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "BJW1v7JxZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HJgxwQ1eW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "SyDbv71lW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "SycvwXyxb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"contentId": "Hk_Ck7Jg-",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p><strong>Newsletter subject line</strong></p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "Skn01X1eW",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "405px",
				"stylePadding": "20px",
				"contentId": "HknIgmygW",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "215px",
				"contentId": "B1TLlQJgb",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rkehlQJeb",
				"contentIsRoot": false,
				"contentParentId": "B1TLlQJgb"
			},
			{
				"contentId": "SJf3gm1lZ",
				"contentIsRoot": false,
				"contentParentId": "rkehlQJeb",
				"contentContent": {
					"imageId": "M671R",
					"imageAlt": "Main Banner",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
					"imageCategory": "banners",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rJbXEQ1e-",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "r14QN7Jgb",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BJP74m1xZ",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"styleWidth": "130px",
				"styleTextAlignment": "left",
				"contentId": "HkQBV7ke-",
				"contentIsRoot": false,
				"contentParentId": "rJbXEQ1e-",
				"contentContent": {
					"imageId": "O351V",
					"imageAlt": "ABI Logo Light",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
					"imageCategory": "logos",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"stylePadding": "10px 0 0",
				"styleTextColour": "#ffffff",
				"contentId": "SywO4XJxb",
				"contentIsRoot": false,
				"contentParentId": "r14QN7Jgb",
				"contentContent": "<h1>Click here to enter text.</h1>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h1"
			},
			{
				"stylePadding": "0",
				"styleTextColour": "#ffffff",
				"contentId": "H1quN71gb",
				"contentIsRoot": false,
				"contentParentId": "BJP74m1xZ",
				"contentContent": "<p>Newsletter date</p>",
				"configId": "RICH_TEXT"
			},
			{
				"styleTextColour": "#ffffff",
				"contentId": "HJ-_rXJgb",
				"contentIsRoot": false,
				"contentParentId": "HkpPHQkgb",
				"contentContent": "<h3>Click here to enter text.</h3>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h3"
			},
			{
				"contentId": "HyEaSXye-",
				"contentIsRoot": false,
				"contentParentId": "SkRhSXklW",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "SECTION_HEADER",
				"contentId": "SykCSQygW",
				"contentIsRoot": false,
				"contentParentId": "HkspHQJeb"
			},
			{
				"styleWidth": "50%",
				"contentId": "HkK-UXyeb",
				"contentIsRoot": false,
				"contentParentId": "BywsHXJlW",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "50%",
				"contentId": "r10-U71l-",
				"contentIsRoot": false,
				"contentParentId": "BywsHXJlW",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByfmU7JeZ",
				"contentIsRoot": false,
				"contentParentId": "HkK-UXyeb"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rJSmIXJxb",
				"contentIsRoot": false,
				"contentParentId": "r10-U71l-"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByI7U7yeZ",
				"contentIsRoot": false,
				"contentParentId": "r10-U71l-"
			},
			{
				"configId": "AUTHOR_BLOCK",
				"contentId": "ryh7IX1xb",
				"contentIsRoot": false,
				"contentParentId": "ByfmU7JeZ"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"contentId": "r1g3mIQ1xb",
				"contentIsRoot": false,
				"contentParentId": "ryh7IX1xb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SybnX8Xylb",
				"contentIsRoot": false,
				"contentParentId": "r1g3mIQ1xb"
			},
			{
				"configId": "IMAGE_ITEM",
				"editorLocked": false,
				"editorDraggable": false,
				"styleTextAlignment": "left",
				"styleWidth": "120px",
				"contentId": "rJGhm8mJlZ",
				"contentIsRoot": false,
				"contentParentId": "SybnX8Xylb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkQ3Q87JeW",
				"contentIsRoot": false,
				"contentParentId": "r1g3mIQ1xb"
			},
			{
				"configId": "RICH_TEXT",
				"editorLocked": false,
				"editorDraggable": false,
				"contentContent": "<p><strong>Author</strong><br/>Job Title</p>",
				"stylePadding": "5px 0",
				"contentId": "HJVh7I7JeZ",
				"contentIsRoot": false,
				"contentParentId": "BkQ3Q87JeW"
			},
			{
				"stylePadding": "0 20px 20px",
				"styleTextAlignment": "left",
				"contentId": "HkkVLQyxW",
				"contentIsRoot": false,
				"contentParentId": "ByI7U7yeZ",
				"configId": "TOC_ITEM"
			},
			{
				"stylePadding": "20px 20px 0px",
				"contentId": "SJENLX1lb",
				"contentIsRoot": false,
				"contentParentId": "rJSmIXJxb",
				"contentContent": "<h4>This issue...</h4>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h4"
			},
			{
				"configId": "SECTION_HEADER",
				"contentId": "r1I0I71g-",
				"contentIsRoot": false,
				"contentParentId": "rJhT8QyxZ"
			},
			{
				"configId": "SECTION_HEADER",
				"contentId": "Hy_CLmyl-",
				"contentIsRoot": false,
				"contentParentId": "r1R6U7JeZ"
			},
			{
				"configId": "RICH_TEXT",
				"contentId": "B19CUQ1xW",
				"contentIsRoot": false,
				"contentParentId": "SywTUQyeW"
			},
			{
				"contentId": "rknAIQJxb",
				"contentIsRoot": false,
				"contentParentId": "ByxRIQ1x-",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "RICH_TEXT",
				"contentId": "rJ71w7yeW",
				"contentIsRoot": false,
				"contentParentId": "BJW1v7JxZ"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "ByTew71x-",
				"contentIsRoot": false,
				"contentParentId": "HJgxwQ1eW"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "Byybv7kxZ",
				"contentIsRoot": false,
				"contentParentId": "HJgxwQ1eW"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "HJZZDXkxZ",
				"contentIsRoot": false,
				"contentParentId": "HJgxwQ1eW"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "rygagPXkeZ",
				"contentIsRoot": false,
				"contentParentId": "ByTew71x-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkWTgD7Jlb",
				"contentIsRoot": false,
				"contentParentId": "rygagPXkeZ"
			},
			{
				"configId": "IMAGE_ITEM",
				"editorLocked": false,
				"editorDraggable": false,
				"styleWidth": "120px",
				"contentId": "S1fpxDQ1l-",
				"contentIsRoot": false,
				"contentParentId": "HkWTgD7Jlb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ryX6gPmyeb",
				"contentIsRoot": false,
				"contentParentId": "rygagPXkeZ"
			},
			{
				"configId": "RICH_TEXT",
				"editorLocked": false,
				"editorDraggable": false,
				"styleTextAlignment": "center",
				"contentContent": "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
				"stylePadding": "5px 0",
				"contentId": "r1N6xv7ylZ",
				"contentIsRoot": false,
				"contentParentId": "ryX6gPmyeb"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "ryxyWvmyeW",
				"contentIsRoot": false,
				"contentParentId": "Byybv7kxZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SybJWwXkx-",
				"contentIsRoot": false,
				"contentParentId": "ryxyWvmyeW"
			},
			{
				"configId": "IMAGE_ITEM",
				"editorLocked": false,
				"editorDraggable": false,
				"styleWidth": "120px",
				"contentId": "rJGy-wQkl-",
				"contentIsRoot": false,
				"contentParentId": "SybJWwXkx-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkQJZP7ygZ",
				"contentIsRoot": false,
				"contentParentId": "ryxyWvmyeW"
			},
			{
				"configId": "RICH_TEXT",
				"editorLocked": false,
				"editorDraggable": false,
				"styleTextAlignment": "center",
				"contentContent": "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
				"stylePadding": "5px 0",
				"contentId": "rkEJ-Dmylb",
				"contentIsRoot": false,
				"contentParentId": "BkQJZP7ygZ"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "SkeZWDm1lZ",
				"contentIsRoot": false,
				"contentParentId": "HJZZDXkxZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Sk-WZDm1eZ",
				"contentIsRoot": false,
				"contentParentId": "SkeZWDm1lZ"
			},
			{
				"configId": "IMAGE_ITEM",
				"editorLocked": false,
				"editorDraggable": false,
				"styleWidth": "120px",
				"contentId": "HJz-WPQkeW",
				"contentIsRoot": false,
				"contentParentId": "Sk-WZDm1eZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "r1QW-wQkgZ",
				"contentIsRoot": false,
				"contentParentId": "SkeZWDm1lZ"
			},
			{
				"configId": "RICH_TEXT",
				"editorLocked": false,
				"editorDraggable": false,
				"styleTextAlignment": "center",
				"contentContent": "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
				"stylePadding": "5px 0",
				"contentId": "BJEbbDXkl-",
				"contentIsRoot": false,
				"contentParentId": "r1QW-wQkgZ"
			},
			{
				"styleTextColour": "#ffffff",
				"contentId": "B1SMwm1gZ",
				"contentIsRoot": false,
				"contentParentId": "SyDbv71lW",
				"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"contentId": "SJCvPX1l-",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "S1WDiwlLG",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI newsletters.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			}
		],
		"builtIn": true
	},
	{
		"templateId": "events",
		"templateName": "Events Template",
		"templateCategory": "",
		"templateContent": [
			{
				"configId": "ROOT_ITEM",
				"contentId": "By8akQ1g-",
				"contentIsRoot": true,
				"contentParentId": null
			},
			{
				"configId": "SECTION",
				"contentId": "S1mAJX1eW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "S1qUlXylb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"contentId": "HkpPHQkgb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "SkRhSXklW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "SyKs57Jx-",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "rykDzVJlZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "Bkmwf41xb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "SyDbv71lW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "SycvwXyxb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"contentId": "Hk_Ck7Jg-",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p><strong>ABI Events</strong></p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "Skn01X1eW",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "405px",
				"stylePadding": "20px",
				"contentId": "HknIgmygW",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "215px",
				"contentId": "B1TLlQJgb",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rkehlQJeb",
				"contentIsRoot": false,
				"contentParentId": "B1TLlQJgb"
			},
			{
				"contentId": "SJf3gm1lZ",
				"contentIsRoot": false,
				"contentParentId": "rkehlQJeb",
				"contentContent": {
					"imageId": "M671R",
					"imageAlt": "Main Banner",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
					"imageCategory": "banners",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rJbXEQ1e-",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "r14QN7Jgb",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"styleWidth": "130px",
				"styleTextAlignment": "left",
				"contentId": "HkQBV7ke-",
				"contentIsRoot": false,
				"contentParentId": "rJbXEQ1e-",
				"contentContent": {
					"imageId": "O351V",
					"imageAlt": "ABI Logo Light",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
					"imageCategory": "logos",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"stylePadding": "10px 0 0",
				"styleTextColour": "#ffffff",
				"contentId": "SywO4XJxb",
				"contentIsRoot": false,
				"contentParentId": "r14QN7Jgb",
				"contentContent": "<h1>ABI Long-Term Savings Conference 2017</h1>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h1"
			},
			{
				"styleTextAlignment": "center",
				"contentId": "HJ-_rXJgb",
				"contentIsRoot": false,
				"contentParentId": "HkpPHQkgb",
				"contentContent": "<h2>Engaging customers for tomorrow's retirement</h2>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h2"
			},
			{
				"styleTextColour": "#ffffff",
				"contentId": "B1SMwm1gZ",
				"contentIsRoot": false,
				"contentParentId": "SyDbv71lW",
				"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"contentId": "SJCvPX1l-",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "S1WDiwlLG",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI updates.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "60%",
				"contentId": "H1a0_X1x-",
				"contentIsRoot": false,
				"contentParentId": "SkRhSXklW",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "40%",
				"contentId": "HJgytX1xW",
				"contentIsRoot": false,
				"contentParentId": "SkRhSXklW",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "SkNxKX1lW",
				"contentIsRoot": false,
				"contentParentId": "H1a0_X1x-"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "H1deYm1l-",
				"contentIsRoot": false,
				"contentParentId": "H1a0_X1x-"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "S12eYX1eW",
				"contentIsRoot": false,
				"contentParentId": "H1a0_X1x-"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BJLzF7ye-",
				"contentIsRoot": false,
				"contentParentId": "H1a0_X1x-"
			},
			{
				"contentId": "r13WtX1lW",
				"contentIsRoot": false,
				"contentParentId": "SkNxKX1lW",
				"contentContent": "<h2>Why Attend?</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "Sy0ZtQylb",
				"contentIsRoot": false,
				"contentParentId": "H1deYm1l-",
				"contentContent": "<ul>\n<li>Hear from the Rt. Hon. Damian Green MP, Secretary of State for Work and Pensions</li>\n<li>Gain insight from senior industry leaders and policy makers on the key issues facing the long-term savings industry.</li>\n<li>Explore what consumer engagement might look like in the future and hear how the regulator intends to enable innovation and protect consumers.</li>\n<li>Take advantage of 4hours worth of CPD with this CII accredited conference.</li>\n</ul>",
				"configId": "RICH_TEXT"
			},
			{
				"contentId": "SJ7GYX1g-",
				"contentIsRoot": false,
				"contentParentId": "S12eYX1eW",
				"contentContent": "<h2>Attendees will gain:</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "B15MY7ylZ",
				"contentIsRoot": false,
				"contentParentId": "BJLzF7ye-",
				"contentContent": "<ul>\n<li>A deeper understanding of next steps for both automatic enrolment and pension freedoms</li>\n<li>A strong overview of how technology can enhance consumer engagement and where the risks lie.</li>\n<li>An understanding of the debates about where responsibility lies for people saving and making retirement choices?</li>\n</ul>\n<p>Speakers will include leading Industry CEO&rsquo;s, Regulators and representatives from Government.&nbsp;</p>\n<ul>\n<li><strong>Rt. Hon. Damian Green MP, </strong>Secretary of State for Work and Pensions</li>\n<li><strong>Andy Briggs</strong>, Chief Executive Officer, UK Insurance, Aviva and ABI Chairman</li>\n<li><strong>John Cridland CBE</strong>, Independent Reviewer of State Pension</li>\n<li><strong>Lesley Titcomb</strong>, Chief Executive, The Pensions Regulator</li>\n<li><strong>Maggie Craig</strong>, Head of Department Pension Policy &amp; Insurance, FCA</li>\n</ul>\n<p><a href=\"https://www.abi.org.uk/events/abi-long-term-savings-conference-2017-engaging-customers-for-tomorrows-retirement/\">Click here</a> to view a full list of confirmed speakers.</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByYPtmJxb",
				"contentIsRoot": false,
				"contentParentId": "HJgytX1xW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BkjvFQkx-",
				"contentIsRoot": false,
				"contentParentId": "HJgytX1xW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "B10vK7ygW",
				"contentIsRoot": false,
				"contentParentId": "HJgytX1xW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rk-tFm1xZ",
				"contentIsRoot": false,
				"contentParentId": "HJgytX1xW"
			},
			{
				"styleTextAlignment": "center",
				"contentId": "B1Nut7Jl-",
				"contentIsRoot": false,
				"contentParentId": "ByYPtmJxb",
				"contentContent": "<p><strong>Date<br /></strong>4th July 2017</p>\n<p><strong>Timings<br /></strong>11:30 (registration from 10:45) - 17:20 followed by networking drinks</p>\n<p><strong>Venue<br /></strong>ABI, One America Square, 17 Crosswall, London EC3N 2LB</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "IMAGE_ITEM",
				"contentId": "rk_uKQ1l-",
				"contentIsRoot": false,
				"contentParentId": "BkjvFQkx-"
			},
			{
				"contentId": "HJnuYQ1x-",
				"contentIsRoot": false,
				"contentParentId": "B10vK7ygW",
				"contentContent": "<p><em>\"I was attracted by the typical quality and mix of speakers and wasn&rsquo;t disappointed!</em></p>\n<p><strong><em>Risk Adviser, FCA</em></strong></p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "IMAGE_ITEM",
				"contentId": "ByLFtQkxb",
				"contentIsRoot": false,
				"contentParentId": "rk-tFm1xZ"
			},
			{
				"stylePadding": "20px 0",
				"contentId": "ByoocQ1lZ",
				"contentIsRoot": false,
				"contentParentId": "SyKs57Jx-",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "S1RsqXyxW",
				"contentIsRoot": false,
				"contentParentId": "ByoocQ1lZ"
			},
			{
				"configId": "IMAGE_ITEM",
				"contentId": "Skx3cmyeZ",
				"contentIsRoot": false,
				"contentParentId": "S1RsqXyxW"
			},
			{
				"configId": "IMAGE_ITEM",
				"contentId": "r1fncXkl-",
				"contentIsRoot": false,
				"contentParentId": "S1RsqXyxW"
			},
			{
				"configId": "IMAGE_ITEM",
				"contentId": "HyE39mJxZ",
				"contentIsRoot": false,
				"contentParentId": "S1RsqXyxW"
			},
			{
				"contentId": "rJOPzNJlZ",
				"contentIsRoot": false,
				"contentParentId": "rykDzVJlZ",
				"contentContent": "<h2>Dates for your diary</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "BycvG4Jl-",
				"contentIsRoot": false,
				"contentParentId": "Bkmwf41xb",
				"contentContent": "<p><strong>29 June 2017 - Windsor</strong> <br /><a href=\"https://www.abi.org.uk/events/international-perspectives-on-international-regulation/\" target=\"_blank\" rel=\"noopener noreferrer\">International Perspectives on International Regulation</a></p>\n<p><strong>4 July 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-long-term-savings-conference-2017-engaging-customers-for-tomorrows-retirement/\" target=\"_blank\" rel=\"noopener noreferrer\">Long-Term Savings Conference 2017: Engaging customers for tomorrow's retirement</a></p>\n<p><strong>12 September 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/ensuring-good-customer-outcomes-in-the-digital-world/\" target=\"_blank\" rel=\"noopener noreferrer\">Ensuring good customer outcomes in the digital world</a></p>\n<p><strong>2 &amp; 3 October 2017 &ndash; Brighton</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-insurance-tax-convention-2017/\" target=\"_blank\" rel=\"noopener noreferrer\">ABI Insurance Tax Convention 2017</a></p>\n<p><strong>19 October 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/insurance-in-the-digital-world-cyber-data-and-technology--from-hype-to-reality/\" target=\"_blank\" rel=\"noopener noreferrer\">Insurance in the digital world: cyber, data and technology &ndash; from hype to reality</a></p>",
				"configId": "RICH_TEXT"
			}
		],
		"builtIn": true
	},
	{
		"templateId": "PA",
		"templateName": "Basic Newsletter",
		"templateCategory": "",
		"templateContent": [
			{
				"configId": "ROOT_ITEM",
				"contentId": "r1hMNj8kb",
				"contentIsRoot": true,
				"contentParentId": null
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "BJ4XVs81-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rJE_fwwJb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rkUr9oLkb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "HkcD5iIyZ",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "SJLRcoL1Z",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "BkJ1jsIy-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "BkBfddvyW",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "HyiGu_DJ-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "HknIO_w1Z",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "BJA8ddw1b",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rkliuOv1W",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "SkXiuuPyZ",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "BydkYOD1b",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rkJwFuDkZ",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "SyCFKuPy-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "HybctdDJZ",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "Hkw9F_Pyb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rkfx9uw1W",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "Hyxv5dPkb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "B1vDq_wJb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "HysPq_P1Z",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "r10P9OvJb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rJwF5uP1-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "SJnKcuPJW",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "S1f5q_vkb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "H1S9qdDyb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "SJ7Wis81-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "S1XN-28y-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "BknKodw1Z",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "rJACk28kb",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "MAIN_ROW",
				"contentId": "r1K82sIJ-",
				"contentIsRoot": false,
				"contentParentId": "r1hMNj8kb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "B1eN7NoUkb",
				"contentIsRoot": false,
				"contentParentId": "BJ4XVs81-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "Hy-V7VsI1-",
				"contentIsRoot": false,
				"contentParentId": "B1eN7NoUkb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1GNmNoUyZ",
				"contentIsRoot": false,
				"contentParentId": "Hy-V7VsI1-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "BJ7Nm4jUy-",
				"contentIsRoot": false,
				"contentParentId": "H1GNmNoUyZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "BJ4Em4oUk-",
				"contentIsRoot": false,
				"contentParentId": "BJ7Nm4jUy-"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "S1SEmNo8JW",
				"contentIsRoot": false,
				"contentParentId": "BJ4Em4oUk-"
			},
			{
				"contentId": "HJwBEiIy-",
				"contentIsRoot": false,
				"contentParentId": "S1SEmNo8JW",
				"contentContent": "<p>Your monthly update on UK public affairs at the ABI</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"contentId": "r1YSEiIJb",
				"contentIsRoot": false,
				"contentParentId": "S1SEmNo8JW",
				"contentContent": "<p style=\"text-align: right;\">Click <a href=\"${Gears.microsite()}\">here</a> if you are having trouble viewing this message.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "B1U9OiLkZ",
				"contentIsRoot": false,
				"contentParentId": "rks4ujU1Z"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "By_9_sIkW",
				"contentIsRoot": false,
				"contentParentId": "B1U9OiLkZ"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "HyH41zvJW",
				"contentIsRoot": false,
				"contentParentId": "B1U9OiLkZ"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "HJi5OiI1-",
				"contentIsRoot": false,
				"contentParentId": "B1U9OiLkZ"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "S17j_jU1Z",
				"contentIsRoot": false,
				"contentParentId": "B1U9OiLkZ"
			},
			{
				"styleWidth": "130px",
				"styleTextAlignment": "left",
				"contentId": "SJ05_sUk-",
				"contentIsRoot": false,
				"contentParentId": "By_9_sIkW",
				"contentContent": {
					"imageId": "O25N",
					"imageAlt": "ABI Logo Light",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
					"imageCategory": "logos",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"styleAltText": "ABI Logo Light"
			},
			{
				"stylePadding": "0",
				"styleTextColour": "#ffffff",
				"styleTextAlignment": "left",
				"contentId": "ByOXFoIJZ",
				"contentIsRoot": false,
				"contentParentId": "HJi5OiI1-",
				"contentContent": "<h1>&nbsp;</h1>\n<h1>ABI General Election 2017</h1>",
				"configId": "RICH_TEXT",
				"configEditorType": "basic",
				"configEditorRoot": "h1"
			},
			{
				"stylePadding": "0",
				"styleTextColour": "#ffffff",
				"styleTextAlignment": "left",
				"contentId": "H1tYYiIkW",
				"contentIsRoot": false,
				"contentParentId": "S17j_jU1Z",
				"contentContent": "<p>3 May 2017</p>",
				"configId": "RICH_TEXT",
				"configEditorType": "basic"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "r1xIrqiUJW",
				"contentIsRoot": false,
				"contentParentId": "rkUr9oLkb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "ryZUr5i8kb",
				"contentIsRoot": false,
				"contentParentId": "r1xIrqiUJW"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ryf8rqj8kW",
				"contentIsRoot": false,
				"contentParentId": "ryZUr5i8kb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "B1m8r5jUy-",
				"contentIsRoot": false,
				"contentParentId": "ryf8rqj8kW"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "BkE8B5jIkW",
				"contentIsRoot": false,
				"contentParentId": "B1m8r5jUy-"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BySLS9oI1W",
				"contentIsRoot": false,
				"contentParentId": "BkE8B5jIkW"
			},
			{
				"configId": "AUTHOR_BLOCK",
				"contentId": "r1-mqvDyb",
				"contentIsRoot": false,
				"contentParentId": "BySLS9oI1W"
			},
			{
				"styleWidth": "50%",
				"stylePadding": "20px",
				"contentId": "H19AFrP1W",
				"contentIsRoot": false,
				"contentParentId": "BySLS9oI1W",
				"configId": "CELL_ITEM"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "Syg5vqsU1-",
				"contentIsRoot": false,
				"contentParentId": "HkcD5iIyZ"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "HkW5DcoU1W",
				"contentIsRoot": false,
				"contentParentId": "Syg5vqsU1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rkM9DqsLk-",
				"contentIsRoot": false,
				"contentParentId": "HkW5DcoU1W"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJ7cv5oLkW",
				"contentIsRoot": false,
				"contentParentId": "rkM9DqsLk-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "ry45PqoIk-",
				"contentIsRoot": false,
				"contentParentId": "HJ7cv5oLkW"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "B1r5wcjLkb",
				"contentIsRoot": false,
				"contentParentId": "ry45PqoIk-"
			},
			{
				"contentId": "SyO3qoLJb",
				"contentIsRoot": false,
				"contentParentId": "B1r5wcjLkb",
				"contentContent": "<p>Good afternoon,</p>\n<p>Welcome to the GE 2017 newsletter from the ABI, with a roundup of the campaign trail from each previous week as we head through the next five weeks of the General Election campaign. If a week was a long time in politics for Harold Wilson in pre-Twitter 1960s Britain, then five weeks could feel like an eternity by modern day standards. The last 12 months have taught us that the political landscape can change in a matter of hours but nevertheless we will keep this note pithy and to the point.&nbsp;</p>\n<p>The political event of the next seven days will, of course, take across the Channel on Sunday &ndash; the 25th President of the French Republic will play an important role in deciding the future of the UK&rsquo;s relationship with the EU. Closer to home, this week sees important local and City mayoral election elections taking place on across Scotland, Wales and England.&nbsp;</p>\n<p>Traditionally at mid-term polls, the governing party is often sent a bloody nose by the electorate but the announcement of the June General Election will mean the hardening of the Conservative vote and frankly the numbers &ndash; polls eh, tsk! &ndash; don&rsquo;t look great for HM Opposition or UKIP in the locals, but maybe Sadiq Khan's success in London can be replicated by Labour in some of the six mayoral votes taking place. Thursday's elections results will form useful data for the parties, as they look to target their efforts in the final month of the election but the most important thing about Thursday will be the political spinning that comes in the wake of it.</p>\n<p>We start our note below with Huw&rsquo;s recent blog below looking at what the General Election could mean for the industry, followed by an assessment of some key legislation &ndash; there is much more below and on our new <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/\">General Election hub</a> which we will be populating on a daily basis as we head towards June 8.&nbsp;</p>\n<p>We&rsquo;ll be back with this note on Monday when we are expecting to see the Conservative Party&rsquo;s 2017 General Election manifesto.</p>\n<p>If you think we can be of help over the next five or six weeks or you have any questions, please don&rsquo;t hesitate to drop us a line.</p>\n<p>Seth</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "H1l80qoIJW",
				"contentIsRoot": false,
				"contentParentId": "SJLRcoL1Z"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "H1-UCci81Z",
				"contentIsRoot": false,
				"contentParentId": "H1l80qoIJW"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ryfUA5oUkW",
				"contentIsRoot": false,
				"contentParentId": "H1-UCci81Z"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ry7ICci81b",
				"contentIsRoot": false,
				"contentParentId": "ryfUA5oUkW"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "HJVUR5o81b",
				"contentIsRoot": false,
				"contentParentId": "ry7ICci81b"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "rkB8AcoL1Z",
				"contentIsRoot": false,
				"contentParentId": "HJVUR5o81b"
			},
			{
				"contentId": "Sy_0cs8Jb",
				"contentIsRoot": false,
				"contentParentId": "rkB8AcoL1Z",
				"contentContent": "<h2>DG General Election Blog - opportunity or obstacle?</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "S1eyyiiIJb",
				"contentIsRoot": false,
				"contentParentId": "BkJ1jsIy-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "r1Z1JojLk-",
				"contentIsRoot": false,
				"contentParentId": "S1eyyiiIJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "B1fkkisLJZ",
				"contentIsRoot": false,
				"contentParentId": "r1Z1JojLk-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJQyksjIkW",
				"contentIsRoot": false,
				"contentParentId": "B1fkkisLJZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "By4k1ji8J-",
				"contentIsRoot": false,
				"contentParentId": "HJQyksjIkW"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "ryB1JssIk-",
				"contentIsRoot": false,
				"contentParentId": "By4k1ji8J-"
			},
			{
				"contentId": "S1ZJsoI1-",
				"contentIsRoot": false,
				"contentParentId": "ryB1JssIk-",
				"contentContent": "<p>Read Huw Evans&rsquo; <a href=\"https://www.abi.org.uk/news/blog-articles/general-election-2017-opportunity-or-obstacle/\">latest blog</a> on the impact of the election for the insurance and long-term savings industry. In the blog Huw argues that whilst the election has caused initial concern in some sectors of the industry, the main impact on much of our work - if the current Government remains in power as the polls indicate &ndash; is delay rather than disruption.</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SJgQWoiI1W",
				"contentIsRoot": false,
				"contentParentId": "SJ7Wis81-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "Sk-mZisUyW",
				"contentIsRoot": false,
				"contentParentId": "SJgQWoiI1W"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SJz7ZosL1W",
				"contentIsRoot": false,
				"contentParentId": "Sk-mZisUyW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "B177bosI1b",
				"contentIsRoot": false,
				"contentParentId": "SJz7ZosL1W"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "SJNQZjoUyZ",
				"contentIsRoot": false,
				"contentParentId": "B177bosI1b"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "B1BX-jiUy-",
				"contentIsRoot": false,
				"contentParentId": "SJNQZjoUyZ"
			},
			{
				"styleTextAlignment": "center",
				"contentId": "HyrZosI1b",
				"contentIsRoot": false,
				"contentParentId": "B1BX-jiUy-",
				"contentContent": "<h2>Meet the Team</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SJxFLnj8JZ",
				"contentIsRoot": false,
				"contentParentId": "r1K82sIJ-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "B1Wt8njUy-",
				"contentIsRoot": false,
				"contentParentId": "SJxFLnj8JZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkGFIno8y-",
				"contentIsRoot": false,
				"contentParentId": "B1Wt8njUy-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "S1mt8hoI1Z",
				"contentIsRoot": false,
				"contentParentId": "BkGFIno8y-"
			},
			{
				"styleWidth": "620px",
				"contentId": "ryVtU2jUyb",
				"contentIsRoot": false,
				"contentParentId": "S1mt8hoI1Z",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BJSYI3sUyW",
				"contentIsRoot": false,
				"contentParentId": "ryVtU2jUyb"
			},
			{
				"contentId": "Bkb_2o8yZ",
				"contentIsRoot": false,
				"contentParentId": "BJSYI3sUyW",
				"contentContent": "<p>If you no longer wish to receive these emails, please <a href=\"${Gears.unsubscribe()}\">unsubscribe</a>.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJxCRkhUk-",
				"contentIsRoot": false,
				"contentParentId": "rJACk28kb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "Sy-ARJ2Iyb",
				"contentIsRoot": false,
				"contentParentId": "HJxCRkhUk-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hkf0RJhU1W",
				"contentIsRoot": false,
				"contentParentId": "Sy-ARJ2Iyb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HkmR01n81W",
				"contentIsRoot": false,
				"contentParentId": "Hkf0RJhU1W"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "HkyJxnIkZ",
				"contentIsRoot": false,
				"contentParentId": "HkmR01n81W"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "rkgJ1en8Jb",
				"contentIsRoot": false,
				"contentParentId": "HkyJxnIkZ"
			},
			{
				"styleBackgroundColour": "#2f1a45",
				"styleTextColour": "#ffffff",
				"contentId": "H1yxnsLJZ",
				"contentIsRoot": false,
				"contentParentId": "rkgJ1en8Jb",
				"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "r1gQEWhI1-",
				"contentIsRoot": false,
				"contentParentId": "S1XN-28y-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "H1bQ4W2Ly-",
				"contentIsRoot": false,
				"contentParentId": "r1gQEWhI1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SJMX4bnIkZ",
				"contentIsRoot": false,
				"contentParentId": "H1bQ4W2Ly-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ByXX4-2Ukb",
				"contentIsRoot": false,
				"contentParentId": "SJMX4bnIkZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "ryVXVb281-",
				"contentIsRoot": false,
				"contentParentId": "ByXX4-2Ukb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "HJS7N-nLkZ",
				"contentIsRoot": false,
				"contentParentId": "ryVXVb281-"
			},
			{
				"stylePadding": "0",
				"contentId": "Bkq41fDJb",
				"contentIsRoot": false,
				"contentParentId": "HyH41zvJW",
				"contentContent": "",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "SJ9ZcHwyZ",
				"contentIsRoot": false,
				"contentParentId": "H19AFrP1W"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "SJ0-crDk-",
				"contentIsRoot": false,
				"contentParentId": "SJ9ZcHwyZ"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BJMGcrwkW",
				"contentIsRoot": false,
				"contentParentId": "SJ9ZcHwyZ"
			},
			{
				"styleTextAlignment": "left",
				"contentId": "ByLG9rP1Z",
				"contentIsRoot": false,
				"contentParentId": "BJMGcrwkW",
				"configId": "TOC_ITEM"
			},
			{
				"stylePadding": "0",
				"contentId": "S1yXqHDJW",
				"contentIsRoot": false,
				"contentParentId": "SJ0-crDk-",
				"contentContent": "<h4>This issue...</h4>",
				"configId": "RICH_TEXT",
				"configEditorType": "basic",
				"configEditorRoot": "h4"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rJgVOfDwy-",
				"contentIsRoot": false,
				"contentParentId": "rJE_fwwJb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "SJbEdzDPyW",
				"contentIsRoot": false,
				"contentParentId": "rJgVOfDwy-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HJfV_zDwkZ",
				"contentIsRoot": false,
				"contentParentId": "SJbEdzDPyW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "H174dfvvkb",
				"contentIsRoot": false,
				"contentParentId": "HJfV_zDwkZ"
			},
			{
				"styleWidth": "620px",
				"styleBackgroundColour": "#2f1a45",
				"contentId": "BkNEdMDvJW",
				"contentIsRoot": false,
				"contentParentId": "H174dfvvkb",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "H1BEdzwDy-",
				"contentIsRoot": false,
				"contentParentId": "BkNEdMDvJW"
			},
			{
				"styleWidth": "405px",
				"contentId": "Sy5_MwvkZ",
				"contentIsRoot": false,
				"contentParentId": "H1BEdzwDy-",
				"configId": "CELL_ITEM"
			},
			{
				"styleWidth": "215px",
				"contentId": "rkh_GvDJZ",
				"contentIsRoot": false,
				"contentParentId": "H1BEdzwDy-",
				"configId": "CELL_ITEM"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "SJ-6zwDJW",
				"contentIsRoot": false,
				"contentParentId": "Sy5_MwvkZ"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BJX6zwvkZ",
				"contentIsRoot": false,
				"contentParentId": "SJ-6zwDJW"
			},
			{
				"styleWidth": "365px",
				"stylePadding": "20px",
				"contentId": "rks4ujU1Z",
				"contentIsRoot": false,
				"contentParentId": "BJX6zwvkZ",
				"configId": "CELL_ITEM",
				"viewAttributes": {
					"valign": "middle",
					"align": "center"
				}
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "r1bEXwv1W",
				"contentIsRoot": false,
				"contentParentId": "rkh_GvDJZ"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "SymNQvDJW",
				"contentIsRoot": false,
				"contentParentId": "r1bEXwv1W"
			},
			{
				"styleWidth": "215px",
				"styleHeight": "200px",
				"contentId": "r1tP8sU1W",
				"contentIsRoot": false,
				"contentParentId": "SymNQvDJW",
				"contentContent": {
					"imageId": "R670P",
					"imageAlt": "Main Banner",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
					"imageCategory": "banners",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"styleAltText": "Main Banner"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"contentId": "Hyg-mcvP1-",
				"contentIsRoot": false,
				"contentParentId": "r1-mqvDyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "B1b-Q9DDJZ",
				"contentIsRoot": false,
				"contentParentId": "Hyg-mcvP1-"
			},
			{
				"styleWidth": "120px",
				"styleTextAlignment": "left",
				"contentId": "HkMbmcPDJb",
				"contentIsRoot": false,
				"contentParentId": "B1b-Q9DDJZ",
				"contentContent": {
					"imageId": "I831R",
					"imageAlt": "Seth Williams",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SethWILLIAMS.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BJ7-m5PP1W",
				"contentIsRoot": false,
				"contentParentId": "Hyg-mcvP1-"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "r1EZm9wDy-",
				"contentIsRoot": false,
				"contentParentId": "BJ7-m5PP1W",
				"contentContent": "<p><strong>Seth Williams</strong><br />Assistant Director, Head of Public Affairs, ABI</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "H18m5DDJ-",
				"contentIsRoot": false,
				"contentParentId": "HJS7N-nLkZ"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "rkKm5vwyb",
				"contentIsRoot": false,
				"contentParentId": "HJS7N-nLkZ"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "B1iX9vPJZ",
				"contentIsRoot": false,
				"contentParentId": "HJS7N-nLkZ"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "H1eI7qwDyb",
				"contentIsRoot": false,
				"contentParentId": "H18m5DDJ-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkbLQqPPkZ",
				"contentIsRoot": false,
				"contentParentId": "H1eI7qwDyb"
			},
			{
				"styleWidth": "120px",
				"contentId": "HJGUXqvD1-",
				"contentIsRoot": false,
				"contentParentId": "BkbLQqPPkZ",
				"contentContent": {
					"imageId": "I831R",
					"imageAlt": "Seth Williams",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SethWILLIAMS.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "S1QLm5vw1W",
				"contentIsRoot": false,
				"contentParentId": "H1eI7qwDyb"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "ByVI7cwvJW",
				"contentIsRoot": false,
				"contentParentId": "S1QLm5vw1W",
				"contentContent": "<p><strong>Seth Williams</strong><br />Assistant Director, Head of Public Affairs<br /><a href=\"mailto:seth.williams@abi.org.uk\" target=\"_blank\" rel=\"noopener noreferrer\">seth.williams@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "B1xFm5DvkZ",
				"contentIsRoot": false,
				"contentParentId": "rkKm5vwyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ry-Y7qDPkZ",
				"contentIsRoot": false,
				"contentParentId": "B1xFm5DvkZ"
			},
			{
				"styleWidth": "120px",
				"contentId": "S1fFQ5vw1W",
				"contentIsRoot": false,
				"contentParentId": "ry-Y7qDPkZ",
				"contentContent": {
					"imageId": "B492B",
					"imageAlt": "Alastair Ross",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkmYm5Dvyb",
				"contentIsRoot": false,
				"contentParentId": "B1xFm5DvkZ"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "HkVtQ9Dwyb",
				"contentIsRoot": false,
				"contentParentId": "HkmYm5Dvyb",
				"contentContent": "<p><strong>Alastair Ross FCIPR</strong><br />Assistant Director, Head of Public Policy (Scotland, Wales &amp; NI)<br /><a href=\"mailto:alastair.ross@abi.org.uk\" target=\"_blank\" rel=\"noopener noreferrer\">alastair.ross@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "r1esX5wvk-",
				"contentIsRoot": false,
				"contentParentId": "B1iX9vPJZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SkZj79Pw1b",
				"contentIsRoot": false,
				"contentParentId": "r1esX5wvk-"
			},
			{
				"styleWidth": "120px",
				"contentId": "Byzj7cPDkb",
				"contentIsRoot": false,
				"contentParentId": "SkZj79Pw1b",
				"contentContent": {
					"imageId": "B628T",
					"imageAlt": "Miranda Cochrane",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MirandaCochrane.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "S1mi79vv1Z",
				"contentIsRoot": false,
				"contentParentId": "r1esX5wvk-"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "By4j79wD1Z",
				"contentIsRoot": false,
				"contentParentId": "S1mi79vv1Z",
				"contentContent": "<p><strong>Miranda Cochrane</strong><br />Public Affairs Manager<br /><a href=\"mailto:miranda.cochrane@abi.org.uk\">miranda.cochrane@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ByxHGu_D1-",
				"contentIsRoot": false,
				"contentParentId": "BkBfddvyW"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "BJ-BG__wyb",
				"contentIsRoot": false,
				"contentParentId": "ByxHGu_D1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rkMBf_uvkZ",
				"contentIsRoot": false,
				"contentParentId": "BJ-BG__wyb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HymBM_dvkb",
				"contentIsRoot": false,
				"contentParentId": "rkMBf_uvkZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "S1NrGddDJZ",
				"contentIsRoot": false,
				"contentParentId": "HymBM_dvkb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BkBBMddPyZ",
				"contentIsRoot": false,
				"contentParentId": "S1NrGddDJZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SJgoGuOw1-",
				"contentIsRoot": false,
				"contentParentId": "HyiGu_DJ-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "HyZjf_ODyb",
				"contentIsRoot": false,
				"contentParentId": "SJgoGuOw1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BJGiGOdvk-",
				"contentIsRoot": false,
				"contentParentId": "HyZjf_ODyb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SkmoMuODyZ",
				"contentIsRoot": false,
				"contentParentId": "BJGiGOdvk-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "SJNsMOOPyb",
				"contentIsRoot": false,
				"contentParentId": "SkmoMuODyZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "SkHjMOuvy-",
				"contentIsRoot": false,
				"contentParentId": "SJNsMOOPyb"
			},
			{
				"contentId": "Hyb7uuD1b",
				"contentIsRoot": false,
				"contentParentId": "BkBBMddPyZ",
				"contentContent": "<h2>What does the General Election mean for the legislative agenda?</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "H1ImuOvkZ",
				"contentIsRoot": false,
				"contentParentId": "SkHjMOuvy-",
				"contentContent": "<p>MPs met for the last time in the House of Commons on Thursday 27th April as Parliament prorogued ahead of the General Election.&nbsp;</p>\n<p>The last two weeks prior to prorogation saw a flurry of legislation pushed through for Royal Assent and a frenzy of select committee activity as members and clerks rushed to wrap up inquiries and publish their findings.</p>\n<p>Read our analysis of which Bills made it through the 'wash up', and those which will need to be reintroduced in the next Parliament <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/general-election-impact-on-legislative-agenda/\" target=\"_blank\" rel=\"noopener noreferrer\">here</a>.&nbsp;</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "Syg28_ODJb",
				"contentIsRoot": false,
				"contentParentId": "HknIO_w1Z"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "HJbnUudvJZ",
				"contentIsRoot": false,
				"contentParentId": "Syg28_ODJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rkM38_dD1b",
				"contentIsRoot": false,
				"contentParentId": "HJbnUudvJZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "r1Q28_OPyW",
				"contentIsRoot": false,
				"contentParentId": "rkM38_dD1b"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "By4hLddwkW",
				"contentIsRoot": false,
				"contentParentId": "r1Q28_OPyW"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BJrhI_OD1W",
				"contentIsRoot": false,
				"contentParentId": "By4hLddwkW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rJl0LduPJW",
				"contentIsRoot": false,
				"contentParentId": "BJA8ddw1b"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "HkW0LOdwyW",
				"contentIsRoot": false,
				"contentParentId": "rJl0LduPJW"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SkGC8uuPk-",
				"contentIsRoot": false,
				"contentParentId": "HkW0LOdwyW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "BJQCUuOvJW",
				"contentIsRoot": false,
				"contentParentId": "SkGC8uuPk-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "ByVCIuuwk-",
				"contentIsRoot": false,
				"contentParentId": "BJQCUuOvJW"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "rkrR8udvJb",
				"contentIsRoot": false,
				"contentParentId": "ByVCIuuwk-"
			},
			{
				"contentId": "ry9vOdvyb",
				"contentIsRoot": false,
				"contentParentId": "BJrhI_OD1W",
				"contentContent": "<h2>Who's up and who's down</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "By4udOwJ-",
				"contentIsRoot": false,
				"contentParentId": "rkrR8udvJb",
				"contentContent": "<p>Several political heavyweights have announced their retirement from the backbenches since the General Election was announced including Ex-Chancellor George Osborne, who continues his role as adviser at BlackRock as well as taking up a new post as Editor of the Evening Standard, and Andrew Tyrie, the outgoing Conservative Chair of the Treasury Select Committee. Iain Wright, the Labour Chair of the Business, Energy and Industrial Strategy has also announced he will not stand, as has the &nbsp;oldest MP of the 2015-17 Parliament Sir Alan Haselhurst, who is retiring after 40 years of political service.</p>\n<p>You can see the full list of MPs standing down on <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/whos-up-and-whos-down/\" target=\"_blank\" rel=\"noopener noreferrer\">our website</a>, which will be updated throughout the General Election period.</p>\n<p>The final list of election candidates will not be published until after nominations close on 11 May, however many local parties have already chosen their preferred candidate in an effort to get their campaigns off the ground as quickly as possible. We were particularly pleased to see Gillian Keegan, Director of Women2Win and close friend of the ABI, chosen as the Conservative candidate for Andrew Tyrie&rsquo;s constituency Chichester, and Vicky Ford MEP chosen to replace the outgoing Conservative Simon Burns in Chelmsford.</p>\n<p>A number of candidates who lost their seat in 2015 are also staged to make a comeback, including Esther McVey, Chris Williamson, Chris Ruane and Sir Bob Russell. Also looking for a comeback from his defeat in December is Zac Goldmsith who is running against Sarah Olney in Richmond Park.&nbsp;</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJeeo_Owy-",
				"contentIsRoot": false,
				"contentParentId": "rkliuOv1W"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "BJZesddDJW",
				"contentIsRoot": false,
				"contentParentId": "HJeeo_Owy-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkMgsd_vyb",
				"contentIsRoot": false,
				"contentParentId": "BJZesddDJW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HkXgjuuwy-",
				"contentIsRoot": false,
				"contentParentId": "HkMgsd_vyb"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "BJ4xi__vyb",
				"contentIsRoot": false,
				"contentParentId": "HkXgjuuwy-"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "HJHxoO_Dyb",
				"contentIsRoot": false,
				"contentParentId": "BJ4xi__vyb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "H1eQoOuw1b",
				"contentIsRoot": false,
				"contentParentId": "SkXiuuPyZ"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "rJb7o__wyW",
				"contentIsRoot": false,
				"contentParentId": "H1eQoOuw1b"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ByzXodODkb",
				"contentIsRoot": false,
				"contentParentId": "rJb7o__wyW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ryQ7id_Dk-",
				"contentIsRoot": false,
				"contentParentId": "ByzXodODkb"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "rJ47juOwJZ",
				"contentIsRoot": false,
				"contentParentId": "ryQ7id_Dk-"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BkSXiOOD1Z",
				"contentIsRoot": false,
				"contentParentId": "rJ47juOwJZ"
			},
			{
				"contentId": "ry-T_dvkb",
				"contentIsRoot": false,
				"contentParentId": "HJHxoO_Dyb",
				"contentContent": "<h2>Poll of Polls</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "By96udwk-",
				"contentIsRoot": false,
				"contentParentId": "BkSXiOOD1Z",
				"contentContent": "<p>This time last week saw the Conservatives flying high in the polls, enjoying a 23 point lead over Labour. However day-by-day, or poll-by-poll, Labour&nbsp;appear to be slowly reducing the lead, to a current one of 15 points. A lot of the gains from both parties are coming from the UKIP vote which appears to be crashing - they have lost 4 points in a month and are now struggling at 7%. The Lib Dems are hovering around the 10% mark, decreasing slightly from the 12% that some polls gave them last week.</p>\n<p>How this all translates into seats will be very interesting, some pollsters are predicting up to a 150 seat majority for the Conservative party and if the Lib Dems can concentrate their efforts into specific seats they should be able to make gains as well. While the gap between the Conservatives and Labour is substantial, Labour will be encouraged by their steady increases in the polls and will use this to show that they are not dead and buried.&nbsp;</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJeu1YuvyZ",
				"contentIsRoot": false,
				"contentParentId": "BydkYOD1b"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "Sy-_JY_Dy-",
				"contentIsRoot": false,
				"contentParentId": "HJeu1YuvyZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HJfdkFOPkW",
				"contentIsRoot": false,
				"contentParentId": "Sy-_JY_Dy-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "S1Xdytdvkb",
				"contentIsRoot": false,
				"contentParentId": "HJfdkFOPkW"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "r1V_kK_PJZ",
				"contentIsRoot": false,
				"contentParentId": "S1Xdytdvkb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "SJrukY_D1b",
				"contentIsRoot": false,
				"contentParentId": "r1V_kK_PJZ"
			},
			{
				"styleWidth": "540\n",
				"contentId": "SyakYODyW",
				"contentIsRoot": false,
				"contentParentId": "SJrukY_D1b",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/poll-of-polls.jpg",
					"imageAlt": "Press Association - Poll of Polls",
					"imageLink": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/poll-of-polls.jpg"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rklJPFuwyW",
				"contentIsRoot": false,
				"contentParentId": "rkJwFuDkZ"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "SyWJDF_D1W",
				"contentIsRoot": false,
				"contentParentId": "rklJPFuwyW"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HJzkDYuv1Z",
				"contentIsRoot": false,
				"contentParentId": "SyWJDF_D1W"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJ71DKdvJ-",
				"contentIsRoot": false,
				"contentParentId": "HJzkDYuv1Z"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "HyEywtuPyb",
				"contentIsRoot": false,
				"contentParentId": "HJ71DKdvJ-"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "SySywKdwkb",
				"contentIsRoot": false,
				"contentParentId": "HyEywtuPyb"
			},
			{
				"contentId": "rymDKdwJZ",
				"contentIsRoot": false,
				"contentParentId": "SySywKdwkb",
				"contentContent": "<p>Image from PA.</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJgRttOP1-",
				"contentIsRoot": false,
				"contentParentId": "SyCFKuPy-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "BkZ0KFuvJ-",
				"contentIsRoot": false,
				"contentParentId": "HJgRttOP1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1GCtF_wk-",
				"contentIsRoot": false,
				"contentParentId": "BkZ0KFuvJ-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "B1Q0tK_PJb",
				"contentIsRoot": false,
				"contentParentId": "H1GCtF_wk-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "HkN0FFOwkZ",
				"contentIsRoot": false,
				"contentParentId": "B1Q0tK_PJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "rkSCYYOvyW",
				"contentIsRoot": false,
				"contentParentId": "HkN0FFOwkZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJx-qKOwyZ",
				"contentIsRoot": false,
				"contentParentId": "HybctdDJZ"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "SkbW9YOPyb",
				"contentIsRoot": false,
				"contentParentId": "HJx-qKOwyZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1fWcFuDJZ",
				"contentIsRoot": false,
				"contentParentId": "SkbW9YOPyb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "Sk7ZqYOPk-",
				"contentIsRoot": false,
				"contentParentId": "H1fWcFuDJZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "ryE-cY_PJb",
				"contentIsRoot": false,
				"contentParentId": "Sk7ZqYOPk-"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "r1BWcYuv1-",
				"contentIsRoot": false,
				"contentParentId": "ryE-cY_PJb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ryxP9FuwkW",
				"contentIsRoot": false,
				"contentParentId": "Hkw9F_Pyb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "SJbvcK_v1-",
				"contentIsRoot": false,
				"contentParentId": "ryxP9FuwkW"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hkfv5Fdvk-",
				"contentIsRoot": false,
				"contentParentId": "SJbvcK_v1-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SkXP9YuDyb",
				"contentIsRoot": false,
				"contentParentId": "Hkfv5Fdvk-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "HyVD9Y_DyZ",
				"contentIsRoot": false,
				"contentParentId": "SkXP9YuDyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BkHv5Yuw1b",
				"contentIsRoot": false,
				"contentParentId": "HyVD9Y_DyZ"
			},
			{
				"contentId": "ByMstuD1W",
				"contentIsRoot": false,
				"contentParentId": "rkSCYYOvyW",
				"contentContent": "<h2>Key Battlegrounds</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "B1ZTKOvyb",
				"contentIsRoot": false,
				"contentParentId": "r1BWcYuv1-",
				"contentContent": "<p>The Conservatives are looking to make gains in a&nbsp;number of key target seats in the North of England and Midlands. They will be hoping that the combination of their Northern Powerhouse messaging, a weak Labour party and constituencies which voted by majority for Leave in the EU referendum will help them gain a significant number of seats from the Labour party. The Leave-voting constituency of Halifax is looking most vulnerable with the narrowest Labour majority of just 428 votes.&nbsp;</p>\n<p>Labour will be targeting the seats with the smallest Conservative majorities, hoping that their messages on the NHS and housing gets through to voters. Candidates will also be flying the Labour flag yet many will be representing&nbsp;themselves independently from Jeremy Corbyn and hoping that his poll ratings do not cling to them.&nbsp;</p>\n<p>The Lib Dems, buoyed by their win in Richmond Park at the end of last year by standing on an anti-Brexit platform will be hoping that the momentum carries on long enough for them to gain back some seats which they lost in 2015. The liberal west of England will have several key target seats as well as constituencies which voted Remain in the referendum, such as Lewes, Twickenham and Cambridge.&nbsp;</p>\n<p>With a range of media outfits offering sage advice, this week we bring you the Telegraph's take on target seats for each of the three main parties as well as the result in 2015. Images courtesy of Ashley Kirk at The Telegraph.&nbsp;</p>",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "580px",
				"contentId": "HJiy5uP1W",
				"contentIsRoot": false,
				"contentParentId": "BkHv5Yuw1b",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/election-and-tory.jpg",
					"imageAlt": "Map 2",
					"imageLink": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/election-and-tory.jpg"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SJgfe5uDyb",
				"contentIsRoot": false,
				"contentParentId": "rkfx9uw1W"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "H1bfecOvJZ",
				"contentIsRoot": false,
				"contentParentId": "SJgfe5uDyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkGfeqdvJ-",
				"contentIsRoot": false,
				"contentParentId": "H1bfecOvJZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "BJ7zl5_Pyb",
				"contentIsRoot": false,
				"contentParentId": "BkGfeqdvJ-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "BJ4zg5OP1-",
				"contentIsRoot": false,
				"contentParentId": "BJ7zl5_Pyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "SyHze9_DJ-",
				"contentIsRoot": false,
				"contentParentId": "BJ4zg5OP1-"
			},
			{
				"styleWidth": "580px",
				"contentId": "SJFgqOwkb",
				"contentIsRoot": false,
				"contentParentId": "SyHze9_DJ-",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/lab-and-ld.jpg",
					"imageAlt": "Map 2",
					"imageLink": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/lab-and-ld.jpg"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rkxxDquwJb",
				"contentIsRoot": false,
				"contentParentId": "Hyxv5dPkb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "BkZxD5OD1-",
				"contentIsRoot": false,
				"contentParentId": "rkxxDquwJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SkfxP9uv1b",
				"contentIsRoot": false,
				"contentParentId": "BkZxD5OD1-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "BJQlP9uw1W",
				"contentIsRoot": false,
				"contentParentId": "SkfxP9uv1b"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "H1VevqOwkW",
				"contentIsRoot": false,
				"contentParentId": "BJQlP9uw1W"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BJHxwq_vyZ",
				"contentIsRoot": false,
				"contentParentId": "H1VevqOwkW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rygDwq_D1-",
				"contentIsRoot": false,
				"contentParentId": "B1vDq_wJb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "HkbPDq_wk-",
				"contentIsRoot": false,
				"contentParentId": "rygDwq_D1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "B1GPvcdvk-",
				"contentIsRoot": false,
				"contentParentId": "HkbPDq_wk-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rk7wPcuDyW",
				"contentIsRoot": false,
				"contentParentId": "B1GPvcdvk-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "SkVwD9dPyb",
				"contentIsRoot": false,
				"contentParentId": "rk7wPcuDyW"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "SkHvP5_w1Z",
				"contentIsRoot": false,
				"contentParentId": "SkVwD9dPyb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HylsD5dDkb",
				"contentIsRoot": false,
				"contentParentId": "HysPq_P1Z"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "SJbow9_vJZ",
				"contentIsRoot": false,
				"contentParentId": "HylsD5dDkb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "r1Msv5dP1-",
				"contentIsRoot": false,
				"contentParentId": "SJbow9_vJZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SJQjP5_DkZ",
				"contentIsRoot": false,
				"contentParentId": "r1Msv5dP1-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "SyNivqOwkZ",
				"contentIsRoot": false,
				"contentParentId": "SJQjP5_DkZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "H1HjwqdDJW",
				"contentIsRoot": false,
				"contentParentId": "SyNivqOwkZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "Bke0w9OvJb",
				"contentIsRoot": false,
				"contentParentId": "r10P9OvJb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "S1-0Dc_DkZ",
				"contentIsRoot": false,
				"contentParentId": "Bke0w9OvJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1fRD5_PJ-",
				"contentIsRoot": false,
				"contentParentId": "S1-0Dc_DkZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rymRwq_wyb",
				"contentIsRoot": false,
				"contentParentId": "H1fRD5_PJ-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "Hy4Cw5ODkb",
				"contentIsRoot": false,
				"contentParentId": "rymRwq_wyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BJr0DqdPy-",
				"contentIsRoot": false,
				"contentParentId": "Hy4Cw5ODkb"
			},
			{
				"contentId": "r1HO9ODJ-",
				"contentIsRoot": false,
				"contentParentId": "BJHxwq_vyZ",
				"contentContent": "<h2>The campaign so far...</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "HJtOqdvJZ",
				"contentIsRoot": false,
				"contentParentId": "SkHvP5_w1Z",
				"contentContent": "<p>Last week saw the parties begin the battle for airtime and soundbites while also trying to bury all of the bad publicity that a General Election inevitably brings.&nbsp;</p>\n<p>Read our roundup of tales from the campaign trail on the <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/from-the-campaign-trail/\">General Election Member Hub here.</a></p>",
				"configId": "RICH_TEXT"
			},
			{
				"contentId": "BJ0ucdvyZ",
				"contentIsRoot": false,
				"contentParentId": "H1HjwqdDJW",
				"contentContent": "<h2>Beyond the Westminster Bubble</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "HJ-K5_v1W",
				"contentIsRoot": false,
				"contentParentId": "BJr0DqdPy-",
				"contentContent": "<p>Away from England, Alastair writes about the poll of Conservative success in Wales which has shocked the other parties, the issue of independence rumbling on in Scotland ahead of their local authority elections tomorrow and all of the goings on in Northern Ireland. You can read Alastair's <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/beyond-the-westminster-bubble/\">latest update here.</a></p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "B1ePY5_DJb",
				"contentIsRoot": false,
				"contentParentId": "rJwF5uP1-"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "ry-vt5dPyW",
				"contentIsRoot": false,
				"contentParentId": "B1ePY5_DJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkGwK9Ovkb",
				"contentIsRoot": false,
				"contentParentId": "ry-vt5dPyW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SymwYqODJb",
				"contentIsRoot": false,
				"contentParentId": "HkGwK9Ovkb"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "Hy4PtcOD1Z",
				"contentIsRoot": false,
				"contentParentId": "SymwYqODJb"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "ByHPt9_wJW",
				"contentIsRoot": false,
				"contentParentId": "Hy4PtcOD1Z"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "SJxhY5OwyZ",
				"contentIsRoot": false,
				"contentParentId": "SJnKcuPJW"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "Bk-ntcuw1-",
				"contentIsRoot": false,
				"contentParentId": "SJxhY5OwyZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hkf2K9dvJ-",
				"contentIsRoot": false,
				"contentParentId": "Bk-ntcuw1-"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "BJQht5OvkZ",
				"contentIsRoot": false,
				"contentParentId": "Hkf2K9dvJ-"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "rJEnFqODyZ",
				"contentIsRoot": false,
				"contentParentId": "BJQht5OvkZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "BJr3K9OwJZ",
				"contentIsRoot": false,
				"contentParentId": "rJEnFqODyZ"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "HJlzqcOPyb",
				"contentIsRoot": false,
				"contentParentId": "S1f5q_vkb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "rkWGqcdPyW",
				"contentIsRoot": false,
				"contentParentId": "HJlzqcOPyb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1zG99uwJZ",
				"contentIsRoot": false,
				"contentParentId": "rkWGqcdPyW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "rkmz9c_D1b",
				"contentIsRoot": false,
				"contentParentId": "H1zG99uwJZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "H1Nz9qOvkW",
				"contentIsRoot": false,
				"contentParentId": "rkmz9c_D1b"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "rkBGqquwkW",
				"contentIsRoot": false,
				"contentParentId": "H1Nz9qOvkW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ByxBq9_PyZ",
				"contentIsRoot": false,
				"contentParentId": "H1S9qdDyb"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "BkZSqqOwkW",
				"contentIsRoot": false,
				"contentParentId": "ByxBq9_PyZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HyzBc9OvJZ",
				"contentIsRoot": false,
				"contentParentId": "BkZSqqOwkW"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "ryXB5q_v1W",
				"contentIsRoot": false,
				"contentParentId": "HyzBc9OvJZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "H1EB59Ov1b",
				"contentIsRoot": false,
				"contentParentId": "ryXB5q_v1W"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "rkHS95_Dkb",
				"contentIsRoot": false,
				"contentParentId": "H1EB59Ov1b"
			},
			{
				"contentId": "HyO99Owkb",
				"contentIsRoot": false,
				"contentParentId": "ByHPt9_wJW",
				"contentContent": "<h2>General Election 2017 member hub</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "HyPj9OPy-",
				"contentIsRoot": false,
				"contentParentId": "BJr3K9OwJZ",
				"contentContent": "<p>To keep members up to date during the pre-election period the ABI has created a <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/\">General Election 2017</a> member hub on the ABI website. Here you will find updates and analysis on what the election will mean for the UK insurance and long-term savings industry and regular insights on the campaigns from the team at the ABI.</p>",
				"configId": "RICH_TEXT"
			},
			{
				"contentId": "Byx2cdP1-",
				"contentIsRoot": false,
				"contentParentId": "rkBGqquwkW",
				"contentContent": "<h2>Want more? Some key sites for election news</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "rkLhcuPyb",
				"contentIsRoot": false,
				"contentParentId": "rkHS95_Dkb",
				"contentContent": "<p>Conservatives: <a href=\"http://www.conservativehome.com/\">www.conservativehome.com&nbsp;<br /></a>Labour: <a href=\"http://labourlist.org/\">www.labourlist.org&nbsp;<br /></a>Liberal Democrats: <a href=\"http://www.libdemvoice.org/\">http://www.libdemvoice.org/&nbsp;</a></p>\n<p>&nbsp;</p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "Byx3YjOv1-",
				"contentIsRoot": false,
				"contentParentId": "BknKodw1Z"
			},
			{
				"configId": "TABLE_ITEM",
				"viewClass": "full-width",
				"editorLocked": true,
				"contentId": "HJ-2KsODJb",
				"contentIsRoot": false,
				"contentParentId": "Byx3YjOv1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkfhFsOwJZ",
				"contentIsRoot": false,
				"contentParentId": "HJ-2KsODJb"
			},
			{
				"configId": "CELL_ITEM",
				"editorLocked": true,
				"contentId": "BJX2Yj_PyZ",
				"contentIsRoot": false,
				"contentParentId": "HkfhFsOwJZ"
			},
			{
				"configId": "TABLE_ITEM",
				"styleWidth": "620px",
				"styleBackgroundColour": "#ffffff",
				"editorLocked": true,
				"contentId": "BJ43FsuDkb",
				"contentIsRoot": false,
				"contentParentId": "BJX2Yj_PyZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorSelectable": false,
				"editorDraggable": false,
				"editorHideable": false,
				"editorCloneable": false,
				"editorDeletable": false,
				"editorEditable": false,
				"editorSaveable": false,
				"contentId": "HyBhKouwkZ",
				"contentIsRoot": false,
				"contentParentId": "BJ43FsuDkb"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "BJZqidDkb",
				"contentIsRoot": false,
				"contentParentId": "HyBhKouwkZ"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "SJI5j_PJZ",
				"contentIsRoot": false,
				"contentParentId": "HyBhKouwkZ"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "Hyq9o_D1-",
				"contentIsRoot": false,
				"contentParentId": "HyBhKouwkZ"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "Syxb5jdDyb",
				"contentIsRoot": false,
				"contentParentId": "BJZqidDkb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ryWW5jdvJ-",
				"contentIsRoot": false,
				"contentParentId": "Syxb5jdDyb"
			},
			{
				"styleWidth": "120px",
				"styleHeight": "120px",
				"contentId": "HkM-cjOP1W",
				"contentIsRoot": false,
				"contentParentId": "ryWW5jdvJ-",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/stefkenyon2.jpg",
					"imageAlt": "Stef Kenyon"
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkXbcouPkb",
				"contentIsRoot": false,
				"contentParentId": "Syxb5jdDyb"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "ByEWqiODJZ",
				"contentIsRoot": false,
				"contentParentId": "HkXbcouPkb",
				"contentContent": "<p><strong>Stephanie Kenyon</strong><br />Public Affairs Manager<br /><a href=\"mailto:stephanie.kenyon@abi.org.uk\">stephanie.kenyon@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "BylLqsdDy-",
				"contentIsRoot": false,
				"contentParentId": "SJI5j_PJZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Sy-Ici_wJ-",
				"contentIsRoot": false,
				"contentParentId": "BylLqsdDy-"
			},
			{
				"styleWidth": "120px",
				"contentId": "BJM8qouwy-",
				"contentIsRoot": false,
				"contentParentId": "Sy-Ici_wJ-",
				"contentContent": {
					"imageId": "J823W",
					"imageAlt": "Rebecca Gladstone",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RebeccaGLADSTONE.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hy789iOv1W",
				"contentIsRoot": false,
				"contentParentId": "BylLqsdDy-"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "H1NI9jOD1W",
				"contentIsRoot": false,
				"contentParentId": "Hy789iOv1W",
				"contentContent": "<p><strong>Rebecca Gladstone</strong><br />Public Affairs Adviser<br /><a href=\"mailto:Rebecca.Gladstone@abi.org.uk\" target=\"_blank\" rel=\"noopener noreferrer\">Rebecca.Gladstone@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "Skgqqi_vyb",
				"contentIsRoot": false,
				"contentParentId": "Hyq9o_D1-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rkbq9juw1W",
				"contentIsRoot": false,
				"contentParentId": "Skgqqi_vyb"
			},
			{
				"styleWidth": "120px",
				"contentId": "B1f99i_wJ-",
				"contentIsRoot": false,
				"contentParentId": "rkbq9juw1W",
				"contentContent": {
					"imageId": "D931X",
					"imageAlt": "Zoe Russell",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/ZoeRussell.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkX5qiOD1-",
				"contentIsRoot": false,
				"contentParentId": "Skgqqi_vyb"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "HkNcqjOD1-",
				"contentIsRoot": false,
				"contentParentId": "HkX5qiOD1-",
				"contentContent": "<p><strong>Zoe Russell</strong><br />Communications &amp; Public Affairs Assistant<br /><a href=\"mailto:zoe.russell@abi.org.uk\">zoe.russell@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			}
		],
		"builtIn": true
	},
	{
		"templateId": "associatemembers",
		"templateName": "Associate Members",
		"templateCategory": "",
		"templateContent": [
			{
				"configId": "ROOT_ITEM",
				"contentId": "By8akQ1g-",
				"contentIsRoot": true,
				"contentParentId": null
			},
			{
				"configId": "SECTION",
				"contentId": "S1mAJX1eW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "S1qUlXylb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "BywsHXJlW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "SkRhSXklW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HkspHQJeb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "SywTUQyeW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "rJhT8QyxZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "ByxRIQ1x-",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "r1R6U7JeZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "BJW1v7JxZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "SJIX2E4--",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HkgL24VWZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HyjzTN4ZW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "Byem6E4WZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "r1SUp44bW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "S1TLaNVW-",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "r11saEV-Z",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "rySi64EWW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "Sk8dyHNbZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "H15ukSV-W",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "BkelgSV-W",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HyFgxS4bZ",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "ry9-gB4Zb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "HJgxwQ1eW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "rk5QeBN-Z",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "r1FMgr4-Z",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "SyDbv71lW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "SycvwXyxb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"contentId": "Hk_Ck7Jg-",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p>The ABI's update for Associate Members and Partners</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "Skn01X1eW",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "405px",
				"stylePadding": "20px",
				"contentId": "HknIgmygW",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "215px",
				"contentId": "B1TLlQJgb",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rkehlQJeb",
				"contentIsRoot": false,
				"contentParentId": "B1TLlQJgb"
			},
			{
				"contentId": "SJf3gm1lZ",
				"contentIsRoot": false,
				"contentParentId": "rkehlQJeb",
				"contentContent": {
					"imageId": "M671R",
					"imageAlt": "Main Banner",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
					"imageCategory": "banners",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rJbXEQ1e-",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "r14QN7Jgb",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BJP74m1xZ",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"styleWidth": "130px",
				"styleTextAlignment": "left",
				"contentId": "HkQBV7ke-",
				"contentIsRoot": false,
				"contentParentId": "rJbXEQ1e-",
				"contentContent": {
					"imageId": "O351V",
					"imageAlt": "ABI Logo Light",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
					"imageCategory": "logos",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"stylePadding": "10px 0 0",
				"styleTextColour": "#ffffff",
				"contentId": "SywO4XJxb",
				"contentIsRoot": false,
				"contentParentId": "r14QN7Jgb",
				"contentContent": "<h1>ABI Associate Member and Partner Newsletter</h1>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h1"
			},
			{
				"stylePadding": "0",
				"styleTextColour": "#ffffff",
				"contentId": "H1quN71gb",
				"contentIsRoot": false,
				"contentParentId": "BJP74m1xZ",
				"contentContent": "<p>??? 2017</p>",
				"configId": "RICH_TEXT"
			},
			{
				"contentId": "HyEaSXye-",
				"contentIsRoot": false,
				"contentParentId": "SkRhSXklW",
				"configId": "RICH_TEXT"
			},
			{
				"contentId": "SykCSQygW",
				"contentIsRoot": false,
				"contentParentId": "HkspHQJeb",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "50%",
				"contentId": "HkK-UXyeb",
				"contentIsRoot": false,
				"contentParentId": "BywsHXJlW",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "50%",
				"contentId": "r10-U71l-",
				"contentIsRoot": false,
				"contentParentId": "BywsHXJlW",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByfmU7JeZ",
				"contentIsRoot": false,
				"contentParentId": "HkK-UXyeb"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rJSmIXJxb",
				"contentIsRoot": false,
				"contentParentId": "r10-U71l-"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByI7U7yeZ",
				"contentIsRoot": false,
				"contentParentId": "r10-U71l-"
			},
			{
				"configId": "AUTHOR_BLOCK",
				"contentId": "ryh7IX1xb",
				"contentIsRoot": false,
				"contentParentId": "ByfmU7JeZ"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"contentId": "r1g3mIQ1xb",
				"contentIsRoot": false,
				"contentParentId": "ryh7IX1xb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SybnX8Xylb",
				"contentIsRoot": false,
				"contentParentId": "r1g3mIQ1xb"
			},
			{
				"styleWidth": "120px",
				"styleTextAlignment": "left",
				"contentId": "rJGhm8mJlZ",
				"contentIsRoot": false,
				"contentParentId": "SybnX8Xylb",
				"contentContent": {
					"imageId": "A110R",
					"imageAlt": "Huw Evans",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HuwEvans.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkQ3Q87JeW",
				"contentIsRoot": false,
				"contentParentId": "r1g3mIQ1xb"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "HJVh7I7JeZ",
				"contentIsRoot": false,
				"contentParentId": "BkQ3Q87JeW",
				"contentContent": "<p><strong>Huw Evans</strong> <br />Director General, ABI <br /><a href=\"https://twitter.com/huwevans71\">@huwevans71</a></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"stylePadding": "0 20px 20px",
				"styleTextAlignment": "left",
				"contentId": "HkkVLQyxW",
				"contentIsRoot": false,
				"contentParentId": "ByI7U7yeZ",
				"configId": "TOC_ITEM"
			},
			{
				"stylePadding": "20px 20px 10px",
				"contentId": "SJENLX1lb",
				"contentIsRoot": false,
				"contentParentId": "rJSmIXJxb",
				"contentContent": "<h4>This issue...</h4>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h4"
			},
			{
				"contentId": "r1I0I71g-",
				"contentIsRoot": false,
				"contentParentId": "rJhT8QyxZ",
				"contentContent": "<h2>General Insurance and Health</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"contentId": "Hy_CLmyl-",
				"contentIsRoot": false,
				"contentParentId": "r1R6U7JeZ",
				"contentContent": "<h2>Europe and International Affairs</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"configId": "RICH_TEXT",
				"contentId": "B19CUQ1xW",
				"contentIsRoot": false,
				"contentParentId": "SywTUQyeW"
			},
			{
				"styleWidth": "460px",
				"contentId": "rknAIQJxb",
				"contentIsRoot": false,
				"contentParentId": "ByxRIQ1x-",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"contentId": "HJWkqNEbW",
				"contentIsRoot": false,
				"contentParentId": "ByxRIQ1x-",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "460px",
				"contentId": "rJ71w7yeW",
				"contentIsRoot": false,
				"contentParentId": "BJW1v7JxZ",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"styleTextAlignment": "Center",
				"contentId": "r1CJ2V4bW",
				"contentIsRoot": false,
				"contentParentId": "BJW1v7JxZ",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "167px",
				"contentId": "ByTew71x-",
				"contentIsRoot": false,
				"contentParentId": "HJgxwQ1eW",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"styleWidth": "166px",
				"contentId": "Byybv7kxZ",
				"contentIsRoot": false,
				"contentParentId": "HJgxwQ1eW",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"styleWidth": "167px",
				"contentId": "HJZZDXkxZ",
				"contentIsRoot": false,
				"contentParentId": "HJgxwQ1eW",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "rygagPXkeZ",
				"contentIsRoot": false,
				"contentParentId": "ByTew71x-"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkWTgD7Jlb",
				"contentIsRoot": false,
				"contentParentId": "rygagPXkeZ"
			},
			{
				"styleWidth": "120px",
				"contentId": "S1fpxDQ1l-",
				"contentIsRoot": false,
				"contentParentId": "HkWTgD7Jlb",
				"contentContent": {
					"imageId": "A110R",
					"imageAlt": "Huw Evans",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HuwEvans.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ryX6gPmyeb",
				"contentIsRoot": false,
				"contentParentId": "rygagPXkeZ"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "r1N6xv7ylZ",
				"contentIsRoot": false,
				"contentParentId": "ryX6gPmyeb",
				"contentContent": "<p><strong>Huw Evans</strong> <br />Director General</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "ryxyWvmyeW",
				"contentIsRoot": false,
				"contentParentId": "Byybv7kxZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SybJWwXkx-",
				"contentIsRoot": false,
				"contentParentId": "ryxyWvmyeW"
			},
			{
				"styleWidth": "120px",
				"contentId": "rJGy-wQkl-",
				"contentIsRoot": false,
				"contentParentId": "SybJWwXkx-",
				"contentContent": {
					"imageId": "Z961W",
					"imageAlt": "James Dalton",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/james-dalton-picture.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BkQJZP7ygZ",
				"contentIsRoot": false,
				"contentParentId": "ryxyWvmyeW"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "rkEJ-Dmylb",
				"contentIsRoot": false,
				"contentParentId": "BkQJZP7ygZ",
				"contentContent": "<p><strong>James Dalton</strong> <br />Director, General Insurance Policy</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "SkeZWDm1lZ",
				"contentIsRoot": false,
				"contentParentId": "HJZZDXkxZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Sk-WZDm1eZ",
				"contentIsRoot": false,
				"contentParentId": "SkeZWDm1lZ"
			},
			{
				"styleWidth": "120px",
				"styleHeight": "120px",
				"contentId": "HJz-WPQkeW",
				"contentIsRoot": false,
				"contentParentId": "Sk-WZDm1eZ",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/braun-yvonne-150x171.jpg"
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "r1QW-wQkgZ",
				"contentIsRoot": false,
				"contentParentId": "SkeZWDm1lZ"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "BJEbbDXkl-",
				"contentIsRoot": false,
				"contentParentId": "r1QW-wQkgZ",
				"contentContent": "<p><strong>Yvonne Braun</strong> <br />Director of Policy, Long Term Savings and Protection</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"styleTextColour": "#ffffff",
				"contentId": "B1SMwm1gZ",
				"contentIsRoot": false,
				"contentParentId": "SyDbv71lW",
				"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"contentId": "SJCvPX1l-",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "S1WDiwlLG",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI newsletters.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "120px",
				"contentId": "HyxWJ5E4-b",
				"contentIsRoot": false,
				"contentParentId": "HJWkqNEbW",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ByWZJqEVZ-",
				"contentIsRoot": false,
				"contentParentId": "HyxWJ5E4-b"
			},
			{
				"styleWidth": "120px",
				"contentId": "SJfZ1qE4b-",
				"contentIsRoot": false,
				"contentParentId": "ByWZJqEVZ-",
				"contentContent": {
					"imageId": "Z961W",
					"imageAlt": "James Dalton",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/james-dalton-picture.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BJQbyc44Wb",
				"contentIsRoot": false,
				"contentParentId": "HyxWJ5E4-b"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "H1E-J5V4W-",
				"contentIsRoot": false,
				"contentParentId": "BJQbyc44Wb",
				"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">James Dalton</span></strong></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"styleWidth": "120px",
				"contentId": "Skl0y34EZW",
				"contentIsRoot": false,
				"contentParentId": "r1CJ2V4bW",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rJb0J2E4Zb",
				"contentIsRoot": false,
				"contentParentId": "Skl0y34EZW"
			},
			{
				"styleWidth": "120px",
				"contentId": "HyGRJ344WZ",
				"contentIsRoot": false,
				"contentParentId": "rJb0J2E4Zb",
				"contentContent": {
					"imageId": "L778O",
					"imageAlt": "Alisa Dolgova",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlisaDOLGOVA.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "S1X0knNEb-",
				"contentIsRoot": false,
				"contentParentId": "Skl0y34EZW"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "HJNA12N4Zb",
				"contentIsRoot": false,
				"contentParentId": "S1X0knNEb-",
				"contentContent": "<p style=\"text-align: center;\"><strong>Alisa Dolgova&nbsp;</strong></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"contentId": "SJ6rh44-Z",
				"contentIsRoot": false,
				"contentParentId": "SJIX2E4--",
				"contentContent": "<h2>Long term savings and protection</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "460px",
				"contentId": "r1mU3ENZW",
				"contentIsRoot": false,
				"contentParentId": "HkgL24VWZ",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"contentId": "r1L82V4WZ",
				"contentIsRoot": false,
				"contentParentId": "HkgL24VWZ",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "120px",
				"contentId": "S1x8IhEE-b",
				"contentIsRoot": false,
				"contentParentId": "r1L82V4WZ",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SJZUIh4E-b",
				"contentIsRoot": false,
				"contentParentId": "S1x8IhEE-b"
			},
			{
				"styleWidth": "120px",
				"contentId": "H1zIU34EW-",
				"contentIsRoot": false,
				"contentParentId": "SJZUIh4E-b",
				"contentContent": {
					"imageId": "Z612B",
					"imageAlt": "Yvonne Braun",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/braun-yvonne-150x171.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rym8Un4NW-",
				"contentIsRoot": false,
				"contentParentId": "S1x8IhEE-b"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "SyVUUhVEW-",
				"contentIsRoot": false,
				"contentParentId": "rym8Un4NW-",
				"contentContent": "<p style=\"text-align: center;\"><strong>Yvonne Braun</strong></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"contentId": "BkRfaEEbZ",
				"contentIsRoot": false,
				"contentParentId": "HyjzTN4ZW",
				"contentContent": "<h2>Conduct regulation</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "460px",
				"contentId": "ByfXTEVZW",
				"contentIsRoot": false,
				"contentParentId": "Byem6E4WZ",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"contentId": "H1HX6E4ZW",
				"contentIsRoot": false,
				"contentParentId": "Byem6E4WZ",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "120px",
				"contentId": "Sylr76NV--",
				"contentIsRoot": false,
				"contentParentId": "H1HX6E4ZW",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SJWBm6EEbW",
				"contentIsRoot": false,
				"contentParentId": "Sylr76NV--"
			},
			{
				"styleWidth": "120px",
				"contentId": "H1GrQTVE-Z",
				"contentIsRoot": false,
				"contentParentId": "SJWBm6EEbW",
				"contentContent": {
					"imageId": "P706H",
					"imageAlt": "James Bridge",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JamesBRIDGE.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "B1mBmaN4ZW",
				"contentIsRoot": false,
				"contentParentId": "Sylr76NV--"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "S14r7TNEZW",
				"contentIsRoot": false,
				"contentParentId": "B1mBmaN4ZW",
				"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">James Bridge&nbsp;</span></strong></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"contentId": "Hk9UT4NW-",
				"contentIsRoot": false,
				"contentParentId": "r1SUp44bW",
				"contentContent": "<h2>Prudential regulation</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "460px",
				"contentId": "rkyPaVVZb",
				"contentIsRoot": false,
				"contentParentId": "S1TLaNVW-",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"contentId": "BkWD6VVZZ",
				"contentIsRoot": false,
				"contentParentId": "S1TLaNVW-",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "120px",
				"contentId": "SyxWDpENZW",
				"contentIsRoot": false,
				"contentParentId": "BkWD6VVZZ",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "S1WWvaNVZZ",
				"contentIsRoot": false,
				"contentParentId": "SyxWDpENZW"
			},
			{
				"styleWidth": "120px",
				"contentId": "BJz-w6NVZb",
				"contentIsRoot": false,
				"contentParentId": "S1WWvaNVZZ",
				"contentContent": {
					"imageId": "H347G",
					"imageAlt": "Steven Findlay",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StevenFINDLAY.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BJ7ZD6EV--",
				"contentIsRoot": false,
				"contentParentId": "SyxWDpENZW"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "rk4Ww6NNZW",
				"contentIsRoot": false,
				"contentParentId": "BJ7ZD6EV--",
				"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">Steven Findlay&nbsp;</span></strong></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"contentId": "rkMoaVNZZ",
				"contentIsRoot": false,
				"contentParentId": "r11saEV-Z",
				"contentContent": "<h2>Taxation</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "460px",
				"contentId": "SJl2a4E-W",
				"contentIsRoot": false,
				"contentParentId": "rySi64EWW",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"contentId": "BkX3TVEbb",
				"contentIsRoot": false,
				"contentParentId": "rySi64EWW",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "120px",
				"contentId": "r1eQ2aVEW-",
				"contentIsRoot": false,
				"contentParentId": "BkX3TVEbb",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rJWmnT4EW-",
				"contentIsRoot": false,
				"contentParentId": "r1eQ2aVEW-"
			},
			{
				"styleWidth": "120px",
				"contentId": "BJfQnpVEZb",
				"contentIsRoot": false,
				"contentParentId": "rJWmnT4EW-",
				"contentContent": {
					"imageId": "I91C",
					"imageAlt": "Stephen Pautard",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StephenPAUTARD.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkQmhp4E-b",
				"contentIsRoot": false,
				"contentParentId": "r1eQ2aVEW-"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "BkNQ3p44b-",
				"contentIsRoot": false,
				"contentParentId": "HkQmhp4E-b",
				"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">Stephen Pautard&nbsp;</span></strong></p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"contentId": "rku_krEZZ",
				"contentIsRoot": false,
				"contentParentId": "Sk8dyHNbZ",
				"contentContent": "<h2>Scotland, Wales and Northern Ireland</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "460px",
				"contentId": "rka_1BVZ-",
				"contentIsRoot": false,
				"contentParentId": "H15ukSV-W",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "120px",
				"contentId": "r102yHN-Z",
				"contentIsRoot": false,
				"contentParentId": "H15ukSV-W",
				"configId": "AUTHOR_BLOCK"
			},
			{
				"styleWidth": "120px",
				"contentId": "H1gCnyBNZ-",
				"contentIsRoot": false,
				"contentParentId": "r102yHN-Z",
				"configId": "TABLE_ITEM",
				"editorLocked": true
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "S1WRh1BNZb",
				"contentIsRoot": false,
				"contentParentId": "H1gCnyBNZ-"
			},
			{
				"styleWidth": "120px",
				"contentId": "HyMAnyBNZb",
				"contentIsRoot": false,
				"contentParentId": "S1WRh1BNZb",
				"contentContent": {
					"imageId": "Z11R",
					"imageAlt": "Alastair Ross",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "BJ7R31H4Zb",
				"contentIsRoot": false,
				"contentParentId": "H1gCnyBNZ-"
			},
			{
				"stylePadding": "5px 0",
				"contentId": "HkVA21HVWW",
				"contentIsRoot": false,
				"contentParentId": "BJ7R31H4Zb",
				"contentContent": "<p style=\"text-align: center;\"><strong>Alastair Ross</strong>&nbsp;</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"contentId": "SkLler4b-",
				"contentIsRoot": false,
				"contentParentId": "BkelgSV-W",
				"contentContent": "<h2>Diversity and Inclusion</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"configId": "RICH_TEXT",
				"contentId": "S1helSVZ-",
				"contentIsRoot": false,
				"contentParentId": "HyFgxS4bZ"
			},
			{
				"contentId": "rJ0ZgB4Wb",
				"contentIsRoot": false,
				"contentParentId": "ry9-gB4Zb",
				"contentContent": "<h2>Meet the team</h2>",
				"configId": "SECTION_HEADER"
			},
			{
				"styleWidth": "167px",
				"contentId": "rkpfeSEZZ",
				"contentIsRoot": false,
				"contentParentId": "r1FMgr4-Z",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"styleWidth": "166px",
				"contentId": "ryxmgr4WW",
				"contentIsRoot": false,
				"contentParentId": "r1FMgr4-Z",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"styleWidth": "167px",
				"contentId": "r1MQgrNZZ",
				"contentIsRoot": false,
				"contentParentId": "r1FMgr4-Z",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "r1lazgSNZb",
				"contentIsRoot": false,
				"contentParentId": "rkpfeSEZZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ryWpfxH4ZZ",
				"contentIsRoot": false,
				"contentParentId": "r1lazgSNZb"
			},
			{
				"styleWidth": "120px",
				"contentId": "BJGTfxBEZZ",
				"contentIsRoot": false,
				"contentParentId": "ryWpfxH4ZZ",
				"contentContent": {
					"imageId": "L778O",
					"imageAlt": "Alisa Dolgova",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlisaDOLGOVA.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hymafgr4Z-",
				"contentIsRoot": false,
				"contentParentId": "r1lazgSNZb"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "HJE6zxrVWb",
				"contentIsRoot": false,
				"contentParentId": "Hymafgr4Z-",
				"contentContent": "<p><strong>Alisa Dolgova</strong> <br />Interim Assistant Director, Head of European &amp; International Affairs</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "S1gxQxrNbZ",
				"contentIsRoot": false,
				"contentParentId": "ryxmgr4WW"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "B1bgQeSN-W",
				"contentIsRoot": false,
				"contentParentId": "S1gxQxrNbZ"
			},
			{
				"styleWidth": "120px",
				"contentId": "BkzlXeSEZ-",
				"contentIsRoot": false,
				"contentParentId": "B1bgQeSN-W",
				"contentContent": {
					"imageId": "Z11R",
					"imageAlt": "Alastair Ross",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rJXe7xr4-W",
				"contentIsRoot": false,
				"contentParentId": "S1gxQxrNbZ"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "HJNx7xHVWW",
				"contentIsRoot": false,
				"contentParentId": "rJXe7xr4-W",
				"contentContent": "<p><strong>Alastair Ross</strong> <br />Assistant Director, Head of Public Policy (Scotland, Wales &amp; NI)</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "SyxMQeSVWZ",
				"contentIsRoot": false,
				"contentParentId": "r1MQgrNZZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HJ-fQgBEbW",
				"contentIsRoot": false,
				"contentParentId": "SyxMQeSVWZ"
			},
			{
				"styleWidth": "120px",
				"contentId": "B1ff7xBEZ-",
				"contentIsRoot": false,
				"contentParentId": "HJ-fQgBEbW",
				"contentContent": {
					"imageId": "F265Z",
					"imageAlt": "Julie Geraud",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JulieGeraud.JPG",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1QzXlBNWW",
				"contentIsRoot": false,
				"contentParentId": "SyxMQeSVWZ"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "BJNGmxBVZ-",
				"contentIsRoot": false,
				"contentParentId": "H1QzXlBNWW",
				"contentContent": "<p><strong>Julie Geraud</strong> <br />Assistant Director, Head of Member Relations, Partnerships and Events</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"styleWidth": "167px",
				"contentId": "rkRmerVZb",
				"contentIsRoot": false,
				"contentParentId": "rk5QeBN-Z",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"styleWidth": "166px",
				"contentId": "r1xEerVbZ",
				"contentIsRoot": false,
				"contentParentId": "rk5QeBN-Z",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "HyeAXeB4WW",
				"contentIsRoot": false,
				"contentParentId": "rkRmerVZb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1-CmeHV-W",
				"contentIsRoot": false,
				"contentParentId": "HyeAXeB4WW"
			},
			{
				"styleWidth": "120px",
				"contentId": "S1MC7eSEWZ",
				"contentIsRoot": false,
				"contentParentId": "H1-CmeHV-W",
				"contentContent": {
					"imageId": "P706H",
					"imageAlt": "James Bridge",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JamesBRIDGE.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HkQCmlHVZZ",
				"contentIsRoot": false,
				"contentParentId": "HyeAXeB4WW"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "ry4AQeBVZb",
				"contentIsRoot": false,
				"contentParentId": "HkQCmlHVZZ",
				"contentContent": "<p><strong>James Bridge</strong> <br />Assistant Director, Head of Conduct Regulation</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "B1elVgSEWZ",
				"contentIsRoot": false,
				"contentParentId": "r1xEerVbZ"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "By-lNxrEW-",
				"contentIsRoot": false,
				"contentParentId": "B1elVgSEWZ"
			},
			{
				"styleWidth": "120px",
				"contentId": "r1GgVxSVZZ",
				"contentIsRoot": false,
				"contentParentId": "By-lNxrEW-",
				"contentContent": {
					"imageId": "H347G",
					"imageAlt": "Steven Findlay",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StevenFINDLAY.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SJQeNlHE-b",
				"contentIsRoot": false,
				"contentParentId": "B1elVgSEWZ"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "SyVlNlHNWb",
				"contentIsRoot": false,
				"contentParentId": "SJQeNlHE-b",
				"contentContent": "<p><strong>Steven Findlay</strong> <br />Assistant Director, Head of Prudential Regulation</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"styleWidth": "167px",
				"contentId": "ryGNgHEWb",
				"contentIsRoot": false,
				"contentParentId": "rk5QeBN-Z",
				"configId": "TEAM_MEMBER_ITEM"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "BJgMNgBEWW",
				"contentIsRoot": false,
				"contentParentId": "ryGNgHEWb"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "H1WM4lBVW-",
				"contentIsRoot": false,
				"contentParentId": "BJgMNgBEWW"
			},
			{
				"styleWidth": "120px",
				"contentId": "rJzf4gHNZW",
				"contentIsRoot": false,
				"contentParentId": "H1WM4lBVW-",
				"contentContent": {
					"imageId": "I91C",
					"imageAlt": "Stephen Pautard",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StephenPAUTARD.jpg",
					"imageCategory": "people",
					"imageAdded": "2017-05-03T13:29:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HyQM4lrVZb",
				"contentIsRoot": false,
				"contentParentId": "BJgMNgBEWW"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "HJNz4eH4-W",
				"contentIsRoot": false,
				"contentParentId": "HyQM4lrVZb",
				"contentContent": "<p><strong>Stephen Pautard</strong> Assistant Director, Head of Taxation</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			}
		],
		"builtIn": true
	},
	{
		"templateId": "eventskeynote",
		"templateName": "Events - Keynote Speakers",
		"templateCategory": "",
		"templateContent": [
			{
				"configId": "ROOT_ITEM",
				"contentId": "By8akQ1g-",
				"contentIsRoot": true,
				"contentParentId": null
			},
			{
				"configId": "SECTION",
				"contentId": "S1mAJX1eW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "S1qUlXylb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"contentId": "HkpPHQkgb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "rkzNCpEVf",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "BkcY1ANNG",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "Bk8aMxS4G",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "rkpeGxHNz",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "BypOd3TrM",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"configId": "SECTION",
				"contentId": "Bkmwf41xb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"styleBackgroundColour": "#230052",
				"contentId": "SyDbv71lW",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-",
				"configId": "SECTION"
			},
			{
				"configId": "SECTION",
				"contentId": "SycvwXyxb",
				"contentIsRoot": false,
				"contentParentId": "By8akQ1g-"
			},
			{
				"contentId": "Hk_Ck7Jg-",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p>Book your place today</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "Skn01X1eW",
				"contentIsRoot": false,
				"contentParentId": "S1mAJX1eW",
				"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "405px",
				"stylePadding": "20px",
				"contentId": "HknIgmygW",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"styleWidth": "215px",
				"contentId": "B1TLlQJgb",
				"contentIsRoot": false,
				"contentParentId": "S1qUlXylb",
				"configId": "COLUMN"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rkehlQJeb",
				"contentIsRoot": false,
				"contentParentId": "B1TLlQJgb"
			},
			{
				"contentId": "SJf3gm1lZ",
				"contentIsRoot": false,
				"contentParentId": "rkehlQJeb",
				"contentContent": {
					"imageId": "M671R",
					"imageAlt": "Main Banner",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
					"imageCategory": "banners",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rJbXEQ1e-",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "r14QN7Jgb",
				"contentIsRoot": false,
				"contentParentId": "HknIgmygW"
			},
			{
				"styleWidth": "130px",
				"styleTextAlignment": "left",
				"contentId": "HkQBV7ke-",
				"contentIsRoot": false,
				"contentParentId": "rJbXEQ1e-",
				"contentContent": {
					"imageId": "O351V",
					"imageAlt": "ABI Logo Light",
					"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
					"imageCategory": "logos",
					"imageAdded": "2017-05-02T19:33:00",
					"builtIn": true
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"stylePadding": "10px 0 0",
				"styleTextColour": "#ffffff",
				"contentId": "SywO4XJxb",
				"contentIsRoot": false,
				"contentParentId": "r14QN7Jgb",
				"contentContent": "<h1>Annual Conference 2018</h1>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h1"
			},
			{
				"styleTextAlignment": "center",
				"contentId": "HJ-_rXJgb",
				"contentIsRoot": false,
				"contentParentId": "HkpPHQkgb",
				"contentContent": "<h2>Keynote speakers&nbsp;</h2>",
				"configId": "RICH_TEXT",
				"configEditorRoot": "h2"
			},
			{
				"styleTextColour": "#ffffff",
				"contentId": "B1SMwm1gZ",
				"contentIsRoot": false,
				"contentParentId": "SyDbv71lW",
				"contentContent": "<p>Copyright &copy;2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"contentId": "SJCvPX1l-",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleTextAlignment": "right",
				"contentId": "S1WDiwlLG",
				"contentIsRoot": false,
				"contentParentId": "SycvwXyxb",
				"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI newsletters.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"contentId": "BycvG4Jl-",
				"contentIsRoot": false,
				"contentParentId": "Bkmwf41xb",
				"contentContent": "<p><strong>4 July 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-long-term-savings-conference-2017-engaging-customers-for-tomorrows-retirement/\" target=\"_blank\" rel=\"noopener noreferrer\">Long-Term Savings Conference 2017: Engaging customers for tomorrow's retirement</a></p>\n<p><strong>12 September 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/ensuring-good-customer-outcomes-in-the-digital-world/\" target=\"_blank\" rel=\"noopener noreferrer\">Ensuring good customer outcomes in the digital world</a></p>\n<p><strong>2 &amp; 3 October 2017 &ndash; Brighton</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-insurance-tax-convention-2017/\" target=\"_blank\" rel=\"noopener noreferrer\">ABI Insurance Tax Convention 2017</a></p>\n<p><strong>19 October 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/insurance-in-the-digital-world-cyber-data-and-technology--from-hype-to-reality/\" target=\"_blank\" rel=\"noopener noreferrer\">Insurance in the digital world: cyber, data and technology &ndash; from hype to reality</a></p>",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "CELL_ITEM",
				"contentId": "S1RVRa4VM",
				"contentIsRoot": false,
				"contentParentId": "rkzNCpEVf"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "HJWBA6ENM",
				"contentIsRoot": false,
				"contentParentId": "S1RVRa4VM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByXr0aE4M",
				"contentIsRoot": false,
				"contentParentId": "HJWBA6ENM"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "ryhSR6E4G",
				"contentIsRoot": false,
				"contentParentId": "ByXr0aE4M"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "BkRSRaNEM",
				"contentIsRoot": false,
				"contentParentId": "ByXr0aE4M"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "Bkl3BCp4Nz",
				"contentIsRoot": false,
				"contentParentId": "ryhSR6E4G"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HJZnBAa44M",
				"contentIsRoot": false,
				"contentParentId": "Bkl3BCp4Nz"
			},
			{
				"styleWidth": "130px",
				"contentId": "ByGnSA6NVz",
				"contentIsRoot": false,
				"contentParentId": "HJZnBAa44M",
				"contentContent": {
					"imageUrl": "",
					"imageAlt": ""
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "r1mnrR6VVz",
				"contentIsRoot": false,
				"contentParentId": "Bkl3BCp4Nz"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "r142SC6VNG",
				"contentIsRoot": false,
				"contentParentId": "r1mnrR6VVz",
				"contentContent": "<p><strong>Rt Hon Nicola Sturgeon MSP</strong><br />First Minister of Scotland</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "Syx0H0TV4f",
				"contentIsRoot": false,
				"contentParentId": "BkRSRaNEM"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "ByWArRTENf",
				"contentIsRoot": false,
				"contentParentId": "Syx0H0TV4f"
			},
			{
				"styleWidth": "150px",
				"contentId": "SyGRSCa4Nz",
				"contentIsRoot": false,
				"contentParentId": "ByWArRTENf",
				"contentContent": {
					"imageUrl": "",
					"imageAlt": ""
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HymRB0p4EM",
				"contentIsRoot": false,
				"contentParentId": "Syx0H0TV4f"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "BJ40r0a4Ez",
				"contentIsRoot": false,
				"contentParentId": "HymRB0p4EM",
				"contentContent": "<p><strong>Sam Woods</strong><br />Chief Executive Officer of the Prudential Regulation Authority</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "CELL_ITEM",
				"contentId": "SJ2FJ0VVM",
				"contentIsRoot": false,
				"contentParentId": "BkcY1ANNG"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "HJ1cJ0EEf",
				"contentIsRoot": false,
				"contentParentId": "SJ2FJ0VVM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "S1xcJRNEM",
				"contentIsRoot": false,
				"contentParentId": "HJ1cJ0EEf"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "r1z9y04VM",
				"contentIsRoot": false,
				"contentParentId": "S1xcJRNEM"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "Skm9yCENM",
				"contentIsRoot": false,
				"contentParentId": "S1xcJRNEM"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "HJgfqk0VNG",
				"contentIsRoot": false,
				"contentParentId": "r1z9y04VM"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rkWz9yAVNf",
				"contentIsRoot": false,
				"contentParentId": "HJgfqk0VNG"
			},
			{
				"styleWidth": "120px",
				"contentId": "SkGM5104VG",
				"contentIsRoot": false,
				"contentParentId": "rkWz9yAVNf",
				"contentContent": {
					"imageUrl": "",
					"imageAlt": ""
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "B17G5yA4EG",
				"contentIsRoot": false,
				"contentParentId": "HJgfqk0VNG"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "Hy4Gqy0VNf",
				"contentIsRoot": false,
				"contentParentId": "B17G5yA4EG",
				"contentContent": "<p><strong>Andy Briggs</strong><br />Chief Executive Officer, UK Insurance, Aviva plc and Chair of the ABI</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "rkxmq10ENf",
				"contentIsRoot": false,
				"contentParentId": "Skm9yCENM"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hy-Q9J0NVM",
				"contentIsRoot": false,
				"contentParentId": "rkxmq10ENf"
			},
			{
				"styleWidth": "120px",
				"contentId": "H1zQqyAVVM",
				"contentIsRoot": false,
				"contentParentId": "Hy-Q9J0NVM",
				"contentContent": {
					"imageUrl": "",
					"imageAlt": ""
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "HJmXq1C4Vf",
				"contentIsRoot": false,
				"contentParentId": "rkxmq10ENf"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "BkE7qyC4EM",
				"contentIsRoot": false,
				"contentParentId": "HJmXq1C4Vf",
				"contentContent": "<p><strong>Andrew Neil</strong><br />Publisher and Broadcaster</p>",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "CELL_ITEM",
				"contentId": "H1xWzxrNM",
				"contentIsRoot": false,
				"contentParentId": "rkpeGxHNz"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "rk7ZGxB4G",
				"contentIsRoot": false,
				"contentParentId": "H1xWzxrNM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "H1NZMlHVz",
				"contentIsRoot": false,
				"contentParentId": "rk7ZGxB4G"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "rk9WGlrEG",
				"contentIsRoot": false,
				"contentParentId": "H1NZMlHVz"
			},
			{
				"configId": "TEAM_MEMBER_ITEM",
				"contentId": "SJ2WMlH4f",
				"contentIsRoot": false,
				"contentParentId": "H1NZMlHVz"
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "BkxcZflHEz",
				"contentIsRoot": false,
				"contentParentId": "rk9WGlrEG"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SJZ5bMgHEG",
				"contentIsRoot": false,
				"contentParentId": "BkxcZflHEz"
			},
			{
				"styleWidth": "190",
				"contentId": "rkM5WfeBVz",
				"contentIsRoot": false,
				"contentParentId": "SJZ5bMgHEG",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/events/html-buttons/click-here-to-register.png",
					"imageAlt": "Click here to register",
					"imageLink": "https://www.abi.org.uk/events/annual-conference-2018/"
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "Hy75-MeHNG",
				"contentIsRoot": false,
				"contentParentId": "BkxcZflHEz"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "S1VcZMeBVG",
				"contentIsRoot": false,
				"contentParentId": "Hy75-MeHNG",
				"contentContent": "",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "TABLE_ITEM",
				"editorLocked": true,
				"styleWidth": "160px",
				"contentId": "H1g2bGgr4f",
				"contentIsRoot": false,
				"contentParentId": "SJ2WMlH4f"
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "rk-3-GlSVG",
				"contentIsRoot": false,
				"contentParentId": "H1g2bGgr4f"
			},
			{
				"styleWidth": "200px",
				"contentId": "Bkf3bfgr4z",
				"contentIsRoot": false,
				"contentParentId": "rk-3-GlSVG",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/events/2017/sponsorspartners/kpmg-new-logo.jpg",
					"imageAlt": "KPMG Logo",
					"imageLink": "https://home.kpmg.com/uk/en/home.html"
				},
				"configId": "IMAGE_ITEM",
				"editorDraggable": false
			},
			{
				"configId": "ROW_ITEM",
				"editorLocked": true,
				"contentId": "SyX2-MlrVz",
				"contentIsRoot": false,
				"contentParentId": "H1g2bGgr4f"
			},
			{
				"stylePadding": "5px 0",
				"styleTextAlignment": "center",
				"contentId": "BkV2bzgBEf",
				"contentIsRoot": false,
				"contentParentId": "SyX2-MlrVz",
				"contentContent": "",
				"configId": "RICH_TEXT",
				"editorDraggable": false
			},
			{
				"configId": "CELL_ITEM",
				"contentId": "SJ3aMxHVM",
				"contentIsRoot": false,
				"contentParentId": "Bk8aMxS4G"
			},
			{
				"configId": "COLUMN",
				"contentId": "HJCaMgHNG",
				"contentIsRoot": false,
				"contentParentId": "Bk8aMxS4G"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "By-0fgHEz",
				"contentIsRoot": false,
				"contentParentId": "HJCaMgHNG"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "rJV0zxS4f",
				"contentIsRoot": false,
				"contentParentId": "SJ3aMxHVM"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "ByUAGxBVz",
				"contentIsRoot": false,
				"contentParentId": "rJV0zxS4f"
			},
			{
				"contentId": "Sy0ZtQylb",
				"contentIsRoot": false,
				"contentParentId": "ByUAGxBVz",
				"contentContent": "<p>The ABI Annual Conference 2018 will be the standout insurance event of the year, bringing industry leaders, politicians and regulators together to debate the major issues affecting the insurance and long term savings industry.&nbsp;</p>\n<p>After our sell-out Brexit conference in 2017, don&rsquo;t miss this chance to find out what&rsquo;s next for the insurance industry in 2018 and how it maintains its place as a UK world leader.</p>",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "250",
				"contentId": "ByKNX0VVz",
				"contentIsRoot": false,
				"contentParentId": "By-0fgHEz",
				"contentContent": "<p style=\"text-align: center;\">&nbsp;<strong>Date<br /></strong>27 February 2018</p>\n<p style=\"text-align: center;\"><strong>Timings<br /></strong>08:45&nbsp;(registration from 08:15) - 17:20&nbsp;followed by networking drinks</p>\n<p style=\"text-align: center;\"><strong>Venue<br /></strong>etc Venues, 155 Bishopsgate, London EC2M 3YD</p>",
				"configId": "RICH_TEXT"
			},
			{
				"contentId": "ry_KOnTrz",
				"contentIsRoot": false,
				"contentParentId": "BypOd3TrM",
				"contentContent": "<h2>Dates for your diary</h2>",
				"configId": "SECTION_HEADER"
			}
		],
		"builtIn": true
	},
	{
		"templateId": "plainoutlook",
		"templateName": "Outlook Email",
		"templateCategory": "",
		"templateContent": [
			{
				"contentId": "SyEoshpHG",
				"contentIsRoot": true,
				"contentParentId": null,
				"configId": "ROOT_ITEM",
				"viewCss": {
					" ": {
						"Margin": "0",
						"border-spacing": "0",
						"font-family": "arial, sans-serif",
						"font-size": "14px",
						"line-height": "18px",
						"color": "#231f20",
						"background-color": "#ffffff",
						"width": "100%",
						"height": "100%",
						"border-width": 0
					},
					"table, tr, td": {
						"font-family": "arial, sans-serif",
						"font-size": "14px",
						"line-height": "18px",
						"color": "#231f20"
					},
					"table": {
						"border-spacing": 0,
						"border-collapse": "collapse",
						"width": "100%"
					},
					"td": {
						"padding-top": 0,
						"padding-right": 0,
						"padding-bottom": 0,
						"padding-left": 0
					},
					"tr": {},
					"a[href]": {
						"color": "#7f58a5",
						"text-decoration": "underline"
					},
					"h1, h2, h3, h4, h5, h6, p, ul, ol, li, hr": {
						"Margin-top": 0,
						"Margin-right": 0,
						"Margin-bottom": "5px",
						"Margin-left": 0
					},
					"h1, h2, h3, h4, h5, h6": {
						"font-weight": "normal",
						"font-size": "18px",
						"line-height": "24px"
					},
					"h1": {
						"font-size": "26px",
						"line-height": "36px"
					},
					"h2": {
						"font-size": "24px"
					},
					"p, ul, ol": {
						"Margin-bottom": "10px"
					},
					"p:last-of-type": {
						"Margin-bottom": 0
					},
					"hr": {
						"color": "#000000"
					},
					"img": {
						"display": "block",
						"margin-top": 0,
						"margin-right": 0,
						"margin-bottom": 0,
						"margin-left": 0,
						"padding-top": 0,
						"padding-right": 0,
						"padding-bottom": 0,
						"padding-left": 0
					},
					"ul": {
						"list-style-type": "disc"
					},
					"ul > li > ul": {
						"list-style-type": "circle"
					},
					"ul > li > ul > li > ul": {
						"list-style-type": "square"
					},
					"ol": {
						"list-style-type": "disc"
					},
					"ol > li > ol": {
						"list-style-type": "circle"
					},
					"ol > li > ol > li > ol": {
						"list-style-type": "square"
					},
					"li": {
						"margin-left": "25px"
					},
					"li > ul, li > ol": {
						"margin-bottom": "5px"
					},
					"p a": {
						"Margin": "inherit",
						"Margin-left": 0,
						"Margin-right": 0
					},
					"strong, b": {
						"font-weight": "bold"
					},
					"em, i": {
						"font-style": "italic"
					},
					"u": {
						"text-decoration": "underline"
					},
					"s": {
						"text-decoration": "line-through"
					},
					"sup, sub": {
						"font-size": "0.8em"
					},
					"sup": {
						"vertical-align": "super"
					},
					"sub": {
						"vertical-align": "sub"
					},
					".full-width": {
						"width": "100%"
					},
					".small": {
						"font-size": "10px",
						"line-height": "11px"
					},
					".editable": {
						"text-align": "left",
						"padding-top": "10px",
						"padding-right": "20px",
						"padding-bottom": "10px",
						"padding-left": "20px"
					},
					".editable *": {
						"padding-top": 0,
						"padding-right": 0,
						"padding-bottom": 0,
						"padding-left": 0
					},
					".section-content-container": {
						"width": "100%",
						"background-color": "#ffffff"
					},
					".main-row:last-of-type": {
						"height": "100%"
					}
				},
				"templateSettings": {
					"backgroundColor": "#ffffff"
				}
			},
			{
				"configId": "SECTION",
				"contentId": "H1CslTaHG",
				"contentIsRoot": false,
				"contentParentId": "SyEoshpHG"
			},
			{
				"configId": "SECTION",
				"contentId": "BJQjd06SM",
				"contentIsRoot": false,
				"contentParentId": "SyEoshpHG"
			},
			{
				"configId": "SECTION",
				"contentId": "rk70uATBz",
				"contentIsRoot": false,
				"contentParentId": "SyEoshpHG"
			},
			{
				"contentId": "r1o2Wy0Bz",
				"contentIsRoot": false,
				"contentParentId": "SyEoshpHG",
				"configId": "SECTION",
				"viewAttributes": {
					"height": "100"
				}
			},
			{
				"configId": "SECTION",
				"contentId": "ry939HkLM",
				"contentIsRoot": false,
				"contentParentId": "SyEoshpHG"
			},
			{
				"stylePadding": "5px",
				"contentId": "SJs9FTarz",
				"contentIsRoot": false,
				"contentParentId": "H1CslTaHG",
				"contentContent": "<p>Dear ${Recipient.contact.firstname},</p>\n<p>Here's an email about stuff we thought was important. Read it.</p>\n<p>Many thanks,</p>\n<p>Sender</p>",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "400px",
				"stylePadding": "5px",
				"styleTextColour": "#2c104b",
				"contentId": "HkYsdR6Bz",
				"contentIsRoot": false,
				"contentParentId": "BJQjd06SM",
				"contentContent": "<p><strong>Sender Name</strong><br />Job Title<br />Association of British Insurers</p>",
				"configId": "RICH_TEXT",
				"viewCss": {
					"p": {
						"font-size": "11px",
						"line-height": "13px"
					}
				}
			},
			{
				"styleWidth": "100%",
				"stylePadding": "5px",
				"contentId": "rkLX1m1LM",
				"contentIsRoot": false,
				"contentParentId": "BJQjd06SM",
				"contentContent": "<p>&nbsp; &nbsp;&nbsp;</p>",
				"configId": "RICH_TEXT"
			},
			{
				"styleWidth": "90px",
				"stylePadding": "5px",
				"styleTextColour": "#2c104b",
				"contentId": "Bk5CuCpSf",
				"contentIsRoot": false,
				"contentParentId": "rk70uATBz",
				"contentContent": "<p><strong>Direct Dial:<br />Mobile:<br />Email:</strong></p>",
				"configId": "RICH_TEXT",
				"viewCss": {
					"p": {
						"font-size": "11px",
						"line-height": "13px"
					}
				}
			},
			{
				"stylePadding": "5px",
				"styleTextColour": "#2c104b",
				"contentId": "Hkl9YRTrG",
				"contentIsRoot": false,
				"contentParentId": "rk70uATBz",
				"contentContent": "<p><a href=\"tel:+44(0)2072167###\">+44 (0)207 216 7###&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;[THESE ARE LINKS. MAKE SURE YOU UPDATE THEM]</a><br /><a href=\"tel:+44(0)7777777777\">+44 (0)777 777 7777</a><br /><a href=\"mailto:firstname.lastname@abi.org.uk\" target=\"_blank\" rel=\"noopener\">firstname.lastname@abi.org.uk</a></p>",
				"configId": "RICH_TEXT",
				"viewCss": {
					"p": {
						"font-size": "11px",
						"line-height": "13px"
					},
					"p a[href]": {
						"text-decoration": "none"
					}
				}
			},
			{
				"styleWidth": "120px",
				"stylePadding": "5px",
				"contentId": "H1aa-1CrG",
				"contentIsRoot": false,
				"contentParentId": "r1o2Wy0Bz",
				"configId": "CELL_ITEM",
				"viewAttributes": {
					"valign": "middle",
					"align": "center"
				}
			},
			{
				"styleWidth": "15px",
				"stylePadding": "0 5px",
				"contentId": "H1h0by0HG",
				"contentIsRoot": false,
				"contentParentId": "r1o2Wy0Bz",
				"configId": "CELL_ITEM"
			},
			{
				"styleWidth": "200px",
				"stylePadding": "0 5px",
				"styleTextColour": "#2c104b",
				"contentId": "r1tGi0arG",
				"contentIsRoot": false,
				"contentParentId": "r1o2Wy0Bz",
				"contentContent": "<p>Association of British Insurers <br />​One America Square, 17 Crosswall, <br />​London EC3N 2LB <br />​T: 020 7600 3333 | abi.org.uk</p>",
				"configId": "RICH_TEXT",
				"viewCss": {
					"p": {
						"font-size": "11px",
						"line-height": "13px"
					}
				}
			},
			{
				"styleWidth": "15px",
				"stylePadding": "0 5px",
				"contentId": "Byy1z1AHz",
				"contentIsRoot": false,
				"contentParentId": "r1o2Wy0Bz",
				"configId": "CELL_ITEM"
			},
			{
				"styleWidth": "30px",
				"stylePadding": "0 10px 0 5px",
				"contentId": "H1-1GkCBz",
				"contentIsRoot": false,
				"contentParentId": "r1o2Wy0Bz",
				"configId": "CELL_ITEM",
				"viewAttributes": {
					"valign": "middle",
					"align": "center"
				}
			},
			{
				"styleWidth": "100%",
				"stylePadding": "5px",
				"contentId": "BJ8um1AHM",
				"contentIsRoot": false,
				"contentParentId": "r1o2Wy0Bz",
				"contentContent": "",
				"configId": "RICH_TEXT"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "BypyfJCSG",
				"contentIsRoot": false,
				"contentParentId": "H1aa-1CrG"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "Sk1gfyRSz",
				"contentIsRoot": false,
				"contentParentId": "BypyfJCSG"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "BkfgGkRSG",
				"contentIsRoot": false,
				"contentParentId": "H1h0by0HG"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "BJSeG1ASG",
				"contentIsRoot": false,
				"contentParentId": "BkfgGkRSG"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "rkdlzkCSG",
				"contentIsRoot": false,
				"contentParentId": "Byy1z1AHz"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "H1qlfk0SG",
				"contentIsRoot": false,
				"contentParentId": "rkdlzkCSG"
			},
			{
				"configId": "TABLE_ITEM",
				"contentId": "BJAgG10rG",
				"contentIsRoot": false,
				"contentParentId": "H1-1GkCBz"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "r1bbMJ0Sf",
				"contentIsRoot": false,
				"contentParentId": "BJAgG10rG"
			},
			{
				"configId": "ROW_ITEM",
				"contentId": "rkX-Gk0Bf",
				"contentIsRoot": false,
				"contentParentId": "BJAgG10rG"
			},
			{
				"contentId": "ByhEoApSG",
				"contentIsRoot": false,
				"contentParentId": "r1bbMJ0Sf",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/twitter.png",
					"imageLink": "https://twitter.com/BritishInsurers"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"contentId": "BJAVjA6Hf",
				"contentIsRoot": false,
				"contentParentId": "rkX-Gk0Bf",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/linkedin.png",
					"imageLink": "https://www.linkedin.com/company/association-of-british-insurers"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"styleHeight": "60",
				"contentId": "r1hWiA6SG",
				"contentIsRoot": false,
				"contentParentId": "H1qlfk0SG",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/vertical-bar.jpg",
					"imageAlt": "|"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"styleHeight": "60px",
				"contentId": "H1LWjCarz",
				"contentIsRoot": false,
				"contentParentId": "BJSeG1ASG",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/vertical-bar.jpg",
					"imageAlt": "|"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"styleWidth": "120px",
				"contentId": "S1f-oR6rG",
				"contentIsRoot": false,
				"contentParentId": "Sk1gfyRSz",
				"contentContent": {
					"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/abi-logo.jpg",
					"imageAlt": "ABI",
					"imageLink": "https://www.abi.org.uk/"
				},
				"configId": "IMAGE_ITEM"
			},
			{
				"styleWidth": "200px",
				"stylePadding": "5px",
				"contentId": "BJ2rdtlIG",
				"contentIsRoot": false,
				"contentParentId": "ry939HkLM",
				"contentContent": "<p><a href=\"https://www.abi.org.uk/account/\">Manage subscription preferences here</a></p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "100px",
				"stylePadding": "5px",
				"contentId": "SypnqSy8z",
				"contentIsRoot": false,
				"contentParentId": "ry939HkLM",
				"contentContent": "<p><a href=\"${Gears.unsubscribe()}\" target=\"_blank\" rel=\"noopener noreferrer\">Unsubscribe here</a>.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "250px",
				"stylePadding": "5px",
				"contentId": "Hyn5Q9AJX",
				"contentIsRoot": false,
				"contentParentId": "ry939HkLM",
				"contentContent": "<p>Click <a href=\"https://www.abi.org.uk/privacy-policy/\">here</a> to read our privacy notice.</p>",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			},
			{
				"styleWidth": "100%",
				"stylePadding": "5px",
				"contentId": "SJsq_tgUz",
				"contentIsRoot": false,
				"contentParentId": "ry939HkLM",
				"contentContent": "",
				"configId": "RICH_TEXT",
				"viewClass": "rich-text small"
			}
		],
		"builtIn": true
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/App/state/templates/initialState.json
// module id = 616
// module chunks = 0